import {
  StyleSheet,
  View,
  Alert,
  Image,
  TouchableOpacity,
  Dimensions,
} from "react-native";
import { useState, useEffect, useContext, memo } from "react";
import {
  InputBox,
  IconButton,
  WebPageView,
  context,
} from "../accessories/accessories.js";
import CustomText from "../accessories/CustomText.js";
import {
  handleAPI,
  FormatPhoneLogin,
  validateEmail,
  log,
  getQueryString,
  updateWebURL,
  getQueryStringURL,
  queryStringToObject,
  handleTrackGA4Events,
  handleGetBrowserName,
  handleGetButtonText,
  handleGetStoredCredential,
  handleSetStoredCredential,
  generateFingerprint,
  handleCreateNewSession,
} from "../accessories/CommonFunctions.js";
import FontAwesome from "react-native-vector-icons/FontAwesome";
import ArrowSpinner from "../accessories/ArrowSpinner.js";
import XMLParser from "react-xml-parser";
import Checkbox from "expo-checkbox";
// import * as SplashScreen from "expo-splash-screen";
import AsyncStorage from "@react-native-async-storage/async-storage";
import ScrollContainer from "../accessories/ScrollContainer.js";
import { REDIRECT_URL } from "@env";
import { web, android } from "../accessories/Platform";
import FingerprintJS from "@fingerprintjs/fingerprintjs-pro";

// const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
// const isAndroid = /Android/.test(navigator.userAgent);
let isForgotPassword = false;

const loginFrom = getQueryString("To", "siteLogin") || "siteLogin",
  emailId = getQueryString("email", "") || "",
  header = getQueryString("header", "0") || "0",
  IISSession = getQueryString("SessionGuid", ""),
  action = getQueryString("action", "");

const LoginWeb = (props) => {
  let isMobileWeb = Dimensions.get("window").width <= 480;
  //For avoid multiple renderng, when loading inside iframe

  if (window.self !== window.top) {
    let isOnload = getQueryString("dummyparam", 0);
    if (
      Number(isOnload) === 0 &&
      (loginFrom === "ratewizard" ||
        loginFrom === "loanapp" ||
        loginFrom === "securedoc")
    )
      return;
  }
  //---------- State Variable declarartion part ----------//
  const { contextDetails, setContextDetails } = useContext(context); //Get value from context
  const { navigation } = props;

  // if (loginFrom === "loanapp") {
  //   setInterval(() => {
  //     try {
  //       window.parent?.resizeLoginIframe();
  //     } catch (error) {}
  //   }, 2000);
  // }

  const [showFooter] = useState(
    !(loginFrom === "ratewizard" || loginFrom === "ratequote")
  );
  const [logInDetails, setLoginDetails] = useState({});
  const [emailSentTo, setEmailSentTo] = useState(null);
  const [IISSessionId, setIISSessionId] = useState(IISSession || "");
  const [disabledButton, setDisabledButton] = useState("");
  const [currentPage, setCurrentPage] = useState(null); //emailOnly
  const [isPasswordSecure, setIsPasswordSecure] = useState(true);
  const [isTerminated, setIsTerminated] = useState(false);
  const [isRemember, setIsRemember] = useState(false);
  const [appIsReady, setAppIsReady] = useState(false);
  const [hideSecureEmail, setHideSecureEmail] = useState(false);
  const [passwordMisMatch, setPasswordMisMatch] = useState("");
  const [deviceId, setDeviceId] = useState(null);
  const [processingStatus, setProcessingStatus] = useState(null);
  const [accesscodeWarningMsg, setAccesscodeWarningMsg] = useState(null);

  const handleGoToHome = () => {
    window.parent.location.href = `${REDIRECT_URL}`;
  };

  const handleGetRouteName = () => {
    let Route = "";
    try {
      Route = window.parent.getQuerystring("Route");
    } catch (error) {
      Route = "";
    }
    if (Route === "") {
      try {
        Route = getQueryString("Route");
      } catch (error) {
        Route = "";
      }
    }
    if (Route === "") {
      try {
        const urlParams = new URLSearchParams(window.location.href);
        Route = urlParams.get("Route");
      } catch (error) {
        Route = "";
      }
    }
    return Route;
  };

  const [Route, setRoute] = useState(handleGetRouteName());

  const [headerText, setHeaderText] = useState(
    loginFrom === "ratequote"
      ? "~~~To Confirm your Rate Lock, let's create a login account. Begin by entering either your email or cell phone."
      : loginFrom === "ratewizard"
      ? `~~~${
          window.parent.glo_CampaignLoginHdr || `Let's get you logged in...`
        }`
      : loginFrom === "Ratesheetsignin"
      ? `~~~${
          window.parent.glo_headermessage ||
          window.top.glo_headermessage ||
          `Let's get you logged in...`
        }`
      : loginFrom === "ratelockleads"
      ? `~~~Absolutely! To view your rates, let's get started by providing your email address or cell phone number.`
      : handleGetRouteName() === "DailyRates"
      ? `~~~Absolutely! To run your own scenario, let's get started by providing your email address or cell phone number.`
      : ["loanapp", "securedoc", "esign", "siteLogin", "RunScenario"].includes(
          loginFrom
        )
      ? `~~~${
          window.parent.glo_CampaignLoginHdr || `Let's get you logged in...`
        }`
      : `~~~Let's get you logged in...`
  );

  const [credentials, setCredentials] = useState({
    userName: "",
    password: "",
    AccessCode: "",
    formattedUserName: "",
  });
  const [errorMessage, setErrorMessage] = useState({
    text: "",
    color: "red",
  });
  const [newPassword, setNewPassword] = useState({
    password: "",
    confirmPassword: "",
  });
  const [newIsPasswordSecure, setNewIsPasswordSecure] = useState({
    password: true,
    confirmPassword: true,
  });
  const [newPasswordMessage, setnewPasswordMessage] = useState({
    passwordMsg: "",
    confirmPasswordMsg: "",
  });
  const [webPageURL, setWebPageURL] = useState(
    // "../../../BorrowerApplication/Presentation/Webforms/DirectDefault.aspx?Skip=1&SessionId={66C11203-4FED-4F93-9137-9D98BD6970A1}"
    null
  );
  const [complianceMsg, setComplianceMsg] = useState(false);
  const CompMsg = `Customers will receive a text message SMS with a verification code and then are prompted for this code in the login interface on our website.\n\nMessage and data rates may apply\nMessage Frequency Varies\nReply “HELP” for help, Reply “STOP” to cancel.`;

  //--------------------------------------------//
  useEffect(() => {
    if (
      [
        "securedoc",
        "loanapp",
        "chat",
        "ratequote",
        "loginverify",
        "RunScenario",
      ].indexOf(loginFrom) > -1
    ) {
      const timer = setInterval(() => {
        try {
          let obj = window.parent.document.getElementById("iframeLogin"),
            height = obj.contentWindow.document.body.scrollHeight;
          if (parseInt(obj.style.height.replace("px", "")) < height)
            try {
              window.parent?.resizeLoginIframe();
            } catch (error) {}
        } catch (error) {}
      }, 500);
      return () => clearInterval(timer);
    }
  }, []);

  useEffect(() => {
    const styleElement = document.createElement("style");

    styleElement.innerHTML = `:focus-visible {
      outline: none !important;
  }`;
    document.head.appendChild(styleElement);

    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);

  //---------- Function declarartion part ----------//
  const handleEmailSentTo = (value) => {
    //Showing (Sent) messange under emial & cellphone
    setEmailSentTo(value);
    //Hide (Sent) messange under emial & cellphone after 2000ms
    setTimeout(() => {
      setEmailSentTo(null);
    }, 3000);
  };
  const updateCredential = (event) => {
    //Handling field value change
    let { name, value, isFormat } = event;
    value = !(value === " ") ? value : "";
    let obj = { [name]: value };
    // if (name === "userName" && value !== "") {
    //   value = value
    //     .replaceAll("-", "")
    //     .replaceAll("(", "")
    //     .replaceAll(")", "")
    //     .replaceAll(" ", "");
    // }
    if (isFormat)
      obj = { [name]: value, formattedUserName: FormatPhoneLogin(value) };
    else if (name === "userName")
      obj = { [name]: value, formattedUserName: value };
    setCredentials({ ...credentials, ...obj });
  };
  const handleClearState = (time) => {
    //resetting the screen after 1000ms
    if (time === 0) {
      handleResetState();
    } else {
      setTimeout(() => {
        handleResetState();
      }, 3000);
    }
  };
  const handleResetState = () => {
    setProcessingStatus(null);
    setIsPasswordSecure(true);
    setCredentials({
      userName: "",
      password: "",
      AccessCode: "",
    });
    setErrorMessage({ text: "", color: "red" });
    setLoginDetails({});
    setIsRemember(false);
    setIsTerminated(false);
    setHideSecureEmail(false);
    setCurrentPage("emailOnly");
    setHeaderText(
      loginFrom === "ratequote"
        ? "~~~To Confirm your Rate Lock, let's create a login account. Begin by entering either your email or cell phone."
        : loginFrom === "ratewizard"
        ? `~~~${
            window.parent.glo_CampaignLoginHdr || `Let's get you logged in...`
          }`
        : `~~~Let's get you logged in...`
    );
  };
  const handleUserNameValidation = () => {
    //Validating the enail and cellphone here
    try {
      let UserName = credentials["userName"]
        .replaceAll("-", "")
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll(" ", "");
      if (
        UserName === "" &&
        headerText.indexOf(`Let's create an account`) !== -1
      ) {
        setErrorMessage({ text: "" });
        return true;
      } else if (Number(UserName) > 0 && UserName.length !== 10) {
        setErrorMessage({ text: "Please enter a valid phone number." });
        return true;
      } else if (!validateEmail(UserName) && UserName.length !== 10) {
        setErrorMessage({
          text: "Please enter a valid email address or Cell Phone number.",
        });
        return true;
      }
    } catch (error) {
      console.log("Error from handleUserNameValidation ====> ", error);
    }
  };

  const handleNextClick = (flag, emailId) => {
    try {
      const userName = emailId || credentials["userName"];
      //---------- if re-entering same login id - will return here. ----------//
      let Emailoutside =
        logInDetails["Emailoutside"] || logInDetails["EmailOutside"];

      if (
        Emailoutside?.toString().toLocaleLowerCase() ===
          userName?.toString().toLocaleLowerCase() ||
        logInDetails["CellPhone"]?.toString().toLocaleLowerCase() ===
          userName?.toString().toLocaleLowerCase()
      ) {
        return false;
      }
      //------------------------------------------------//
      //setLoginDetails({}); //Clear details if exist

      //---------- Validating username ----------//

      if (handleUserNameValidation()) return false;
      if (flag || isForgotPassword) return false;
      setProcessingStatus("Next");
      //------------------------------------------------//
      try {
        updateCredential({
          name: "formattedUserName",
          value: userName,
          isFormat: userName.indexOf("@") === -1 ? true : false,
        });
      } catch (error) {}
      setDisabledButton("Next"); //Disable the Next button
      setComplianceMsg(false);
      //---------- Checking the login exist or not ----------//

      handleAPI({
        name: "GetUserNameExists",
        params: { userName: userName },
      }).then((response) => {
        response = JSON.parse(response)["Table"][0];
        response = { ...response, ...logInDetails };

        setLoginDetails(response);
        if (!isForgotPassword) {
          if (Number(response["UserExists"]) === 1) {
            if (emailId && false) {
              const { CellPhone = "", EmailOutside, Emailoutside } = response;

              const msg =
                CellPhone && (EmailOutside || Emailoutside)
                  ? `Welcome <b style='color:black; font-weight:bold'>${response["UserDisplayName"]}.</b>Run your own scenario. We've Emailed and Texted you an access code just to verify it's really you. Enter it below.`
                  : `Welcome <b style='color:black; font-weight:bold'>${
                      response["UserDisplayName"]
                    }.</b>Run your own scenario. We've ${
                      emailId.indexOf("@") === -1 ? "Text" : "Emailed"
                    } you an access code just to verify it's really you. Enter it below.`;

              handleAccessCodeLogin(3, response, msg);
            } else {
              setHeaderText(
                `~~~Welcome back <b style='color:black; font-weight:bold'>${response["UserDisplayName"]}.</b>Please select a login option below.`
              );
            }

            //Login exist - proceed next step
            if (parseInt(response["AccountTerminated"]) === 1) {
              setCurrentPage("loginOption");

              setLoginDetails({ ...response });
            } else handleGetDeviceId(response);
          } else if (parseInt(response["UserExists"]) === 0) {
            //login not exist - entering signup process
            navigate("Signup", {
              userName: userName,
              deviceId: deviceId,
            });
            handleClearState(); //resetting the screen
          }
        }
      });
      //------------------------------------------------//
    } catch (error) {
      setProcessingStatus(null);
      log("Error from handleNextClick ====> ", error);
    }
  };
  const handleGetDeviceId = async (logDetails) => {
    let userName = logDetails["EmailOutside"] || logDetails["Emailoutside"];

    //---------- Checking the device id stored for the lognin ----------//
    if (
      logDetails["DeviceId"] === undefined ||
      logDetails["DeviceId"] === "null"
    ) {
      logDetails["DeviceId"] = await handleGetNewDeviceId();
    }
    try {
      handleAPI({
        name: "GetDeviceFingerPrintWeb",
        params: {
          UserName: userName,
          DeviceId: logDetails["DeviceId"] || deviceId,
        },
      }).then((response) => {
        try {
          response = response.split("~");
          let obj = {
            deviceIdExist: Number(response[0]) || 0,
            saveCredential: response[1] || 0,
          };
          logDetails = { ...logDetails, ...obj };
        } catch (error) {
          log("Error from ====> GetDeviceFingerPrintWeb", error);
        }
        handleCreateSessionWebLogin(logDetails);
      });
    } catch (error) {
      log("Error from handleGetDeviceId ====> ", error);
    }
    //------------------------------------------------//
  };
  const handleCreateSessionWebLogin = (logDetails) => {
    try {
      //---------- Creating new seesion for the lognin ----------//

      let { WebLoginId } = logDetails;
      handleAPI({
        name: "CreateSessionWrapper",
        params: { WebLoginId: WebLoginId },
      }).then((response) => {
        response = response.split("~");
        let res = { SessionId: response[0], loginName: response[1] };
        if (window.location.host.indexOf("localhost") === -1)
          handleUpdateIISSession(response[0]);
        logDetails = { ...logDetails, ...res };
        if (logDetails["isForgotPassword"]) {
          //For forgot password flow
          logDetails = { ...logInDetails, ...logDetails };
          if (loginFrom === "esign") {
            LoanBased = handleCheckLoanBased(response[0]);
            logDetails = { ...logDetails, LoanBased: LoanBased };
          }
          handleGetNextStepWeb(logDetails);
        } else {
          //General flow for to login
          handleCheckPasscodeExpired(logDetails);
        }
      });
    } catch (error) {
      log("Error from handleCreateSessionWebLogin ====> ", error);
    }
    //------------------------------------------------//
  };
  const handleCheckLoanBased = async (SessionId) => {
    await handleAPI({
      name: "CheckIfLoanBasedWeb",
      params: { SessionId: SessionId },
    })
      .then((LoanBased) => {
        return LoanBased;
      })
      .catch((e) => log("Error from ====> CheckIfLoanBasedWeb", e));
  };
  const handleOpenPage = (page) => {
    let URL = "";

    if (page == 1) {
      URL = `https://www.directmortgage.com/terms-of-use/`;
    }
    if (page == 2) {
      URL = `https://www.directmortgage.com/privacy-policy/`;
    }

    window.open(URL, "_blank", "width=750,height=780,resizable=1,scrollbars=1");
  };
  const handleGetNextStepWeb = async (logDetails) => {
    try {
      //---------- Get which page to enter based on user type ----------//
      let { SessionId, UserType } = logDetails;
      handleAPI({
        name: "GetNextStepWeb",
        params: { SessionId: SessionId, username: "", IP: "::1" },
      }).then(async (response) => {
        response = JSON.parse(response)["Table"][0];
        let URL = response["Column1"];
        if (URL != "" && URL != null && URL != undefined) {
          //=====================

          let LoanOfficerId = getQuerystring_document("loanofficer=", "0");
          let PartnerId = getQuerystring_document("PartnerId=", "0");

          if (loginFrom === "loanapp") {
            URL = URL.replace("DashBoard", "Home");
            URL += "&loanOfficerId=" + LoanOfficerId;
            if (PartnerId != 0) URL += "&PartnerId=" + PartnerId;
          }

          URL = `${URL}&Skip=1`;
          if (UserType == "C") {
            //URL = `../../../BorrowerLanding/Presentation/Webforms/BorrowerWelcome.aspx?SessionId=${SessionId}&To=${loginFrom}`; //"BorrowerWelcome";
            URL = `${window.location.origin}/GoDirect/index.html?Path=DashBoard&SessionId=${SessionId}`;
            URL += "&loanOfficerId=" + LoanOfficerId;
            if (PartnerId != 0) URL += "&PartnerId=" + PartnerId;
          }
          if (UserType == "V" || UserType == "M")
            URL = `../../../esignpackage/index.html?SessionId=${SessionId}`;

          if (UserType === "E") {
            if (
              loginFrom != "esign" &&
              loginFrom != "chat" &&
              loginFrom != "ratequote"
            )
              logDetails = await handleCheckIsSignUpdoneWeb(logDetails);
            if (logDetails["URL"]) {
              setLoginDetails(logDetails);
              return;
            }
          }
          let StartLoanApp = getQueryString("StartLoanApp", "0");
          if (loginFrom == "ratewizard") {
            let GatherDataId = 0, //checkValue(GatherId || 0, "0"),
              From = checkValue(getQueryString("From", ""), "0"),
              RateQuoteId = checkValue(getQueryString("RateQuoteId", ""), "0"),
              PublicRateQuoteId = checkValue(
                getQueryString("PublicRateQuoteId", ""),
                "0"
              ),
              LoanOfficerId = checkValue(getQueryString("loanofficer", ""), 0),
              HomePage = getQueryString("HomePage", "0");

            if (LoanOfficerId == 0)
              LoanOfficerId =
                window.parent.document.getElementById("spnUserInfo").attributes
                  .empnum.value;

            LoanOfficerId = checkValue(LoanOfficerId, 0);
            if (LoanOfficerId == 0) LoanOfficerId = "1";

            if (StartLoanApp == 1) {
              //URL = `../../../BorrowerLanding/Presentation/Webforms/BorrowerWelcome.aspx?SessionId=${SessionId}&StartLoanApp=1&To=${loginFrom}`; //"BorrowerWelcome";

              URL = `${window.location.origin}/GoDirect/index.html?Path=DashBoard&SessionId=${SessionId}&StartLoanApp=1`;
            } else {
              if (HomePage == 1) {
                try {
                  window.parent.glo_SessionId = SessionId;
                  let obj = { URL: URL };
                  logDetails = { ...logDetails, ...obj };
                  logDetails = { ...logInDetails, ...logDetails };
                  setLoginDetails(logDetails);
                  return false;
                } catch (e) {}
              }

              URL = `../../../rates/rates-wizard.php?SessionId=${SessionId}&GatherId=${GatherDataId}&From=${From}&LoanOfficerId=${LoanOfficerId}&${
                PublicRateQuoteId > 0
                  ? `PublicRateQuoteId=${PublicRateQuoteId}`
                  : `RateQuoteId=${RateQuoteId}`
              }`;
            }
            window.parent.glo_SessionId = SessionId;
            let obj = { URL: URL };
            logDetails = { ...logDetails, ...obj };
            logDetails = { ...logInDetails, ...logDetails };
            setLoginDetails(logDetails);
            return false;
          }
          if (
            loginFrom == "securedoc" ||
            loginFrom == "loanapp" ||
            (loginFrom == "ratewizard" && StartLoanApp == 1)
          ) {
            // logDetails["noDirect"] = true;
            logDetails = { ...logInDetails, ...logDetails };
            setLoginDetails(logDetails);
            // handleSecureDocLogin(0, 1, StartLoanApp, logDetails); //P
            return;
            // URL = document.getElementById("lnkNextURL").attributes.href;
          }

          // document.getElementById("lnkNextURL").attributes.href = URL;

          if (
            (logDetails["AutoRedirect"] || logInDetails["AutoRedirect"]) &&
            (logDetails["PasscodeExpired"] ||
              logInDetails["PasscodeExpired"]) !== 1
          ) {
            let obj = { URL: URL };
            logDetails = { ...logDetails, ...obj };
            logDetails = { ...logInDetails, ...logDetails };
            setLoginDetails(logDetails);
            return;
          }

          //=====================

          let obj = { URL: URL };
          logDetails = { ...logDetails, ...obj };
          logDetails = { ...logInDetails, ...logDetails };

          setLoginDetails(logDetails); //Storing login details in state
        }
      });
    } catch (error) {
      log("Error from handleGetNextStepWeb ====> ", error);
    }
    //------------------------------------------------//
  };
  const handleSetCookies = (logDetails) => {
    let {
        WebLoginId,
        UserDisplayName,
        URL,
        EmailOutside,
        Emailoutside,
        CellPhone,
        UserName,
        DeviceId,
        UserType,
        loginName,
      } = logDetails,
      date = new Date();
    date.setDate(date.getDate() + 30);

    let objectToStore = {
      WebLoginId: WebLoginId,
      UserDisplayName: UserDisplayName,
      URL: URL,
      UserName: EmailOutside || Emailoutside || UserName || CellPhone,
      AutoRedirectExpiryDate:
        //WebLoginId == 99766 ? new Date().getTime() + 60000 * 2 :
        date.getTime(), //getExpireDate(60), //in Minutes - getExpireDate(No. of days)
      AutoRedirect: true,
      UserDisplayName: loginName || UserDisplayName,
      DeviceId: DeviceId || deviceId,
      UserType: UserType,
      //====
      // UserWebLoginId: WebLoginId,
      // UserRememberDevice: 1,
      // UserDeviceId: deviceId,
      // UserRedirectURL: URL,
    };
    AsyncStorage.removeItem("Credentials");
    AsyncStorage.setItem("Credentials", JSON.stringify(objectToStore) || null);

    // Object.keys(objectToStore).map((key) => {
    //   setCookies(key, objectToStore[key], {
    //     // expires: new Date(Date.now() + 365 * 100 * 24 * 60 * 60 * 1000),
    //     path: "/",
    //     domain: "",
    //     secure: "",
    //   });
    // });
  };

  const handleChatProcess = (logDetails) => {
    let ChatWithId = getQueryString("ChatWithId", 0),
      url = "";
    if (ChatWithId == "" || ChatWithId == null || ChatWithId == undefined)
      ChatWithId = 0;

    if (ChatWithId == 0)
      url = `../../../ChatSession/Presentation/Webforms/ChatMenu.aspx?SessionId=${logDetails["SessionId"]}&zid=${logDetails["WebLoginId"]}`;
    else
      url = `../../../ChatSession/Presentation/Webforms/ChatMenu.aspx?SessionId=${logDetails["SessionId"]}&zid=${logDetails["WebLoginId"]}&ChatWithId=${ChatWithId}`;
    if (isRemember) handleSetCookies({ ...logDetails, URL: url });
    try {
      window.parent.location.href = url;
    } catch (e) {
      window.location.href = url;
    }
  };

  const handleEsignProcess = (logDetails) => {
    let ReDirectURL = "",
      packageId = getQueryString("WebPackage", ""),
      { SessionId, WebLoginId, UserId } = logDetails;
    packageId = packageId?.split(".")[0];
    if (packageId != "" && WebLoginId != "" && SessionId != "") {
      handleAPI({
        name: "ValidPackage",
        params: {
          Package: packageId,
          WebLoginId: WebLoginId,
          SessionId: SessionId,
        },
      })
        .then((response) => {
          if (response == 1) {
            let strPackage = packageId;
            strPackage = strPackage.split("-");
            let LoanId = strPackage[1];
            ReDirectURL = `../../../EsignWebstage/SignPageContent_SinglePageView.aspx?SessionId=${SessionId}&UserId=${UserId}&FromPage=EsignNow&Package=${packageId}&LoanId=${LoanId}`;
          } else {
            ReDirectURL = `../../../esignpackage/index.html?SessionId=${SessionId}`;
          }
          if (isRemember) handleSetCookies({ ...logDetails, URL: ReDirectURL });
          try {
            window.parent.location.href = ReDirectURL;
          } catch (e) {
            window.location.href = ReDirectURL;
          }
        })
        .catch((e) => log("Error from ===> ValidPackage", e));
    } else if (SessionId != "") {
      ReDirectURL = `../../../esignpackage/index.html?SessionId=${SessionId}`;
      if (isRemember) handleSetCookies({ ...logDetails, URL: ReDirectURL });
      try {
        window.parent.location.href = ReDirectURL;
      } catch (e) {
        window.location.href = ReDirectURL;
      }
    }
  };
  const handleSecureDocLogin = (flag, JustGetUrl, StartLoanApp, logDetails) => {
    if (JustGetUrl === 0) {
      setErrorMessage({
        color: "#999",
        text: (
          <CustomText>
            <ArrowSpinner />
            {"  "}
            Processing...Please wait...
          </CustomText>
        ),
        italic: false,
      });
    }
    let LoanNum = 0,
      SessionId = logDetails["SessionId"];
    handleAPI({
      name: "CheckActiveLoans",
      params: { sessionid: SessionId },
    })
      .then((response) => {
        if (response.indexOf("root") > -1 && flag == 0) {
          let parseXML = new DOMParser().parseFromString(response, "text/xml");
          if (
            loginFrom === "loanapp" ||
            loginFrom === "securedoc" ||
            (loginFrom === "ratewizard" && StartLoanApp === 1)
          ) {
            const activeCount = parseXML
              .querySelector("root row")
              .getAttribute("activecount");
            if (Number(activeCount) >= 1) {
              const rows = parseXML.querySelectorAll("row");
              rows.forEach((row) => {
                if (row.getAttribute("status") === "Active") {
                  const loanId = Number(row.getAttribute("LoanId"));
                  handleSelectLoan(
                    loanId !== 0 ? loanId : 0,
                    JustGetUrl,
                    SessionId,
                    logDetails
                  );
                }
              });
              return;
            }
          }

          handleSelectLoan(LoanNum, JustGetUrl, SessionId, logDetails);
        } else {
          handleSelectLoan(LoanNum, JustGetUrl, SessionId, logDetails);
        }
      })
      .catch((e) => log("Error from CheckActiveLoans ====>", e));
  };
  const handleSelectLoan = (loanid, JustGetUrl, SessionId, logDetails) => {
    let LOId = "";
    let PublicPage = getQueryString("Publicpage", "");
    if (loanid == 0 && loginFrom != "loanapp") {
      setErrorMessage({
        color: "#999",
        text: (
          <CustomText>
            <ArrowSpinner />
            {"  "}
            Loan Creation is in progress. Please wait...
          </CustomText>
        ),
        italic: false,
      });
      try {
        LOId = window?.parent?.getQuerystring("empnum", "");
      } catch (error) {}
      try {
        if (
          loginFrom == "securedoc" ||
          loginFrom == "loanapp" ||
          loginFrom == "ratequote"
        ) {
          if (LOId == 0 || LOId == null || LOId == "" || LOId == undefined) {
            try {
              LOId = window?.parent?.getQuerystring("loanofficer", "");
            } catch (error) {}
          }
          if (LOId == 0 || LOId == null || LOId == "" || LOId == undefined)
            LOId =
              window.parent.document.getElementById("spnUserInfo").attributes
                .empnum.value;
        }
      } catch (e) {}
      try {
        if (loginFrom == "ratewizard") {
          let LoanOfficerId = getQueryString("loanofficer", "");
          if (
            LoanOfficerId == 0 ||
            LoanOfficerId == null ||
            LoanOfficerId == "" ||
            LoanOfficerId == undefined
          )
            LOId = "1";
          else LOId = LoanOfficerId;
        }
      } catch (e) {}

      if (LOId == "0" || LOId == null || LOId == "" || LOId == undefined)
        LOId = "1";

      handleAPI({
        name: "CreateLoanOnly",
        params: { sessionid: SessionId, empid: LOId, EventId: 15 },
      })
        .then((response) => {
          loanid = JSON.parse(response);
          if (loanid != 0) {
            //let URL = `../../../BorrowerLanding/Presentation/Webforms/BorrowerWelcome.aspx?SessionId=${SessionId}&LoanId=${loanid}&To=${loginFrom}`;

            let URL = `${window.location.origin}/GoDirect/index.html?Path=Home&SessionId=${SessionId}&loanId=${loanid}`;

            // if (loanid > 0 && loginFrom == "securedoc" && PublicPage == "1") {
            if (loanid > 0 && loginFrom == "securedoc" && PublicPage == "1") {
              URL += "&GoToNav=9&PublicPage=1";
            }

            handleAssociateLoanId(SessionId, URL);

            if (logDetails["noDirect"]) {
              logDetails["URL"] = URL;
              setLoginDetails({ ...logInDetails, ...logDetails });
            } else {
              try {
                window.parent.location = URL;
              } catch (e) {
                window.location = URL;
              }
            }
          }
        })
        .catch((error) => log("Error from CreateLoanOnly ====> ", error));
    } else {
      let URL = "";
      if (getQueryString("Route", "") === "dmloanapp") {
        try {
          // URL = `../../../BorrowerLanding/Presentation/Webforms/BorrowerWelcome.aspx?SessionId=${SessionId}&${
          //   window.location.href.split("?")[1]
          // }`;

          URL = `${
            window.location.origin
          }/GoDirect/index.html?Path=DashBoard&SessionId=${SessionId}&${
            window.location.href.split("?")[1]
          }`;
        } catch (error) {}
      } else {
        // URL = `../../../BorrowerLanding/Presentation/Webforms/BorrowerWelcome.aspx?SessionId=${SessionId}&LoanId=${loanid}&To=${loginFrom}`;

        if (loanid > 0)
          URL = `${window.location.origin}/GoDirect/index.html?Path=DashBoard&SessionId=${SessionId}&loanId=${loanid}`;
        else
          URL = `${window.location.origin}/GoDirect/index.html?Path=DashBoard&SessionId=${SessionId}&loanId=-999`;

        let LoanOfficerId = getQuerystring_document("loanofficer=", "0");
        if (loginFrom === "securedoc") {
          URL = URL.replace("DashBoard", "Home");
          URL += "&GoToNav=9&loanOfficerId=" + LoanOfficerId;
          if (PublicPage == "1") {
            URL += "&PublicPage=1";
          }
        }
        let PartnerId = getQuerystring_document("PartnerId=", "0");

        if (loginFrom === "loanapp") {
          URL = URL.replace("DashBoard", "Home");
          URL += "&loanOfficerId=" + LoanOfficerId;
          if (PartnerId != 0) URL += "&PartnerId=" + PartnerId;
        }
      }

      handleAssociateLoanId(SessionId, URL);

      if (logDetails["noDirect"]) {
        logDetails["URL"] = URL;
        setLoginDetails({ ...logInDetails, ...logDetails });
      } else {
        try {
          window.parent.location = URL;
        } catch (e) {
          window.location = URL;
        }
      }
    }
  };
  const handleAssociateLoanId = (SessionId, NextURL) => {
    let Loginmethod = "";
    if (NextURL.indexOf("To=securedoc") !== -1) Loginmethod = "UploadDocs";

    if (NextURL.indexOf("To=ratewizard") !== -1) {
      if (document.documentURI.indexOf("CustomizeOptions=1") !== -1) {
        Loginmethod = "CustomizeOptions";
      } else Loginmethod = "LockThisIntRate";
    }
    let LoanId = getQueryStringURL("LoanId", "", NextURL);
    if (LoanId == "" || Loginmethod == "") return;

    try {
      handleAPI({
        name: "AssociateLoanId_GA",
        params: {
          SessionId: SessionId,
          LoanId: LoanId,
          LoginMethod: Loginmethod,
        },
      })
        .then((response) => {
          log("response", response);
        })
        .catch((e) => log("Error from ====>", e));
    } catch (error) {}
  };

  const checkValue = (value, def) => {
    if (
      Number(value) === 0 ||
      value === "" ||
      value === null ||
      value === undefined
    )
      return def || "0";
    return value;
  };
  const handleCheckIsSignUpdoneWeb = async (logDetails) => {
    //---------- Checking signup process is completed or still pending  ----------//
    try {
      let { SessionId, URL, WebLoginId } = logDetails;
      await handleAPI({
        name: "CheckIsSignUpdoneWeb",
        params: { SessionId: SessionId },
      }).then((response) => {
        if (response !== "{}") {
          response = JSON.parse(response)["Table"][0];
          let {
            IsSignUpComplete,
            ApprovalStatus,
            ApprovalTaskExists,
            CertDone,
            EmpNum,
            CompNum,
            logintype,
          } = response;
          let SignUpURL = "";
          if (Number(CompNum) !== 1000) {
            SignUpURL =
              Number(IsSignUpComplete) === 0 || Number(IsSignUpComplete) === 2
                ? `../../../BorrowerApplication/Presentation/Webforms/SignUpWizard.aspx?WID=${WebLoginId}&SessionId=${SessionId}&EmpNum=${EmpNum}&CompNum=${CompNum}&FromLanding=0&FromProfile=&PType=${logintype}`
                : Number(IsSignUpComplete) === -3 &&
                  Number(ApprovalStatus) === 3 &&
                  Number(CertDone) === -1
                ? `../../../BorrowerApplication/Presentation/Webforms/SignUpWizard.aspx?WID=${WebLoginId}&SessionId=${SessionId}&EmpNum=${EmpNum}&CompNum=${CompNum}&FromLanding=0&FromProfile=&PType=${logintype}`
                : Number(IsSignUpComplete) === -3
                ? `../../../BorrowerApplication/Presentation/Webforms/SignUpWizard.aspx?WID=${WebLoginId}&SessionId=${SessionId}&EmpNum=${EmpNum}&CompNum=${CompNum}&FromLanding=0&FromProfile=&PType=${logintype}`
                : Number(ApprovalStatus) === 4 &&
                  Number(ApprovalTaskExists) === 0
                ? `../../../BorrowerApplication/Presentation/Webforms/NewBrokerApproval.aspx?SessionId=${SessionId}&EmpNum=${EmpNum}&CompNum=${CompNum}`
                : "";
          }

          if (SignUpURL) {
            logDetails = { ...logDetails, URL: SignUpURL };
          }
          return logDetails;
        }
      });
    } catch (error) {
      log("Error from handleCheckIsSignUpdoneWeb ====> ", error);
    }
    return logDetails;
    //------------------------------------------------//
  };
  const handleCheckPasscodeExpired = (logDetails) => {
    try {
      //---------- Checking Password is expired or not for the lognin ----------//

      let { WebLoginId, SessionId } = logDetails;
      handleAPI({
        name: "CheckPasscodeExpired",
        params: {
          WebLoginId: WebLoginId,
          SessionId: SessionId,
        },
      }).then((response) => {
        response = JSON.parse(response)["Table"][0];
        logDetails = { ...logDetails, ...response };
        //---------- Password is expired and not a terminated login - Sending access code to user ----------//
        if (
          (parseInt(response["PasscodeExpired"]) === 1 &&
            parseInt(logDetails["AccountTerminated"]) !== 1) ||
          (logDetails["AutoRedirectCheck"] && !logDetails["AutoRedirect"])
        ) {
          let msg = `${logDetails["UserDisplayName"]}--It looks like your passcode has expired. Please validate to renew your passcode.`;
          handleAccessCodeLogin(1, logDetails, msg);
        }
        //--------------------------------------------//
        //Manual login flow
        else if (!logDetails["AutoRedirect"]) {
          if (!emailId || credentials["existingFlowRunScenario"]) {
            setCurrentPage("loginOption");
          }
          if (!currentPage === "enterAccessCode") {
            logDetails = { ...logDetails, isEnterAccessCode: false };
          }
        }
        //Auto redirecting flow
        else if (logDetails["AutoRedirect"]) {
          handleLogin(undefined, logDetails);
          return false;
        }
        handleGetNextStepWeb(logDetails);
      });
    } catch (error) {
      log("Error from handleCheckPasscodeExpired ====> ", error);
    }
  };

  const handleUpdateUserEmailInCTA = async (EmailId) => {
    let DeviceId = 0,
      PageLoadId =
        window?.parent?.GLO_PageLoadId ||
        (await AsyncStorage.getItem("PageLoadId")) ||
        0,
      Buttontext = handleGetButtonText(loginFrom);

    try {
      DeviceId = JSON.parse((await AsyncStorage.getItem("DeviceId")) || 0);
    } catch (error) {
      DeviceId = (await AsyncStorage.getItem("DeviceId")) || 0;
    }

    await handleAPI({
      name: "UpdateUserEmailInCTA",
      params: {
        Buttontext,
        PageLoadId,
        EmailId,
        DeviceId,
      },
    }).then((response) => {});
  };
  const handleLogin = async (flag, logDetails) => {
    if (!logDetails["SessionId"]) {
      logDetails["SessionId"] = await handleCreateNewSession(
        logDetails["WebLoginId"]
      );
    }
    setDisabledButton("");
    if (loginFrom !== "securedoc") {
      let CampaignDetails = JSON.parse(
        (await AsyncStorage.getItem("CampaignDetails")) || null
      );
      if (
        CampaignDetails &&
        CampaignDetails["WebLoginId"] == logDetails["WebLoginId"]
      ) {
        AsyncStorage.removeItem("CampaignDetails");
      }
    }
    //---------- If any actice session is found for the user Showing Procees & Wait option ----------//
    // if (!(window.self !== window.top)) {
    if (parseInt(logDetails["MultiLogin"]) === 1 && flag === undefined) {
      setCurrentPage("multiLogin");
      let { Emailoutside, EmailOutside, UserDisplayName } = logDetails;
      setHeaderText(
        `~~~${
          Emailoutside || EmailOutside || UserDisplayName || ""
        }--It looks like you're currently logged in on another device. Would you like to proceed?`
      );
      logDetails = { ...logDetails, AutoRedirectCheck: true };
      logDetails = { ...logDetails, ...logInDetails };
      setLoginDetails(logDetails);
      return false;
    }

    // }
    //--------------------------------------------//
    //---------- If User clicked Proceed option - it will close all active session ----------//
    if (currentPage === "setPassword&Login") {
      setProcessingStatus("loginNow");
    } else setProcessingStatus("validating");

    if (
      flag === 1 ||
      (window.self !== window.top &&
        (loginFrom === "ratewizard" ||
          loginFrom === "loanapp" ||
          loginFrom === "securedoc"))
    ) {
      setProcessingStatus("proceeding");
      handleCloseOtherSession(logDetails);
    }
    //--------------------------------------------//
    let emailId =
      logDetails["EmailOutside"] || logDetails["Emailoutside"] || "";

    await handleLogDWCallToActionEventParent("Login", emailId);

    setContextDetails((prevContextDetails) => {
      return { ...prevContextDetails, Email: emailId };
    });

    if (isRemember) {
      handleSetStoredCredential(1, {
        ...logDetails,
        ...logInDetails,
        DeviceId: deviceId,
      }); //Storing details for auto re-direct
      handleLogAutoGAEventPasscode(); //Storing login log - auto re-direct
      handleAPI({
        name: "SaveDeviceFingerPrintWeb",
        params: {
          UserName: emailId,
          DeviceId: deviceId,
          SaveResp: 1,
          WebLoginId: logDetails["WebLoginId"],
        },
      }).then((response) => {});
    } else {
      //handleSetStoredCredential(2); //Clearing details of auto re-direct
      handleLogGAEventPasscode(); //Storing login log - Manual
    }
    await handleUpdateUserEmailInCTA(emailId);
    //Navigating to mobile applicaiton
    let HomePage = await getQueryString("HomePage", "0");

    if (
      ((logDetails["URL"] || "")?.indexOf("GoDirect") !== -1 ||
        getQueryString("From", "") === "LoanOfficerWebsite") &&
      [516595, 1, 99766, 3486].includes(logDetails["WebLoginId"])
    ) {
      let params = queryStringToObject(logDetails["URL"]);
      params = {
        ...{
          userName: logDetails["UserDisplayName"],
          SessionId: logDetails["SessionId"],
          WebLoginId: logDetails["WebLoginId"],
        },
        ...params,
      };
      setContextDetails((prevContextDetails) => {
        return { ...prevContextDetails, ...params };
      });

      // let queryString=
      //       for (const [key, value] of Object.entries(params)) {
      //         if (value && key !== "navigation") {
      //           //key === "Path" || key === "SessionId") -- removed for web login -> dashboard
      //           queryString.set(key, value);
      //         } else {
      //           queryString.delete(key);
      //         }
      //       }
      //        try {
      //                 window.parent.location.href = queryString;
      //               } catch (e) {
      //                 window.location.href = queryString;
      //               }
      if (logDetails["URL"].toLowerCase().includes("wizard")) {
        try {
          window.parent.location.href = logDetails["URL"];
        } catch (e) {
          window.location.href = logDetails["URL"];
        }
      } else navigate("DashBoard", params);
    } else {
      //The Below code for redirecting Appropriate pages.
      const { WebLoginId, EmailOutside, Emailoutside, SessionId } = logDetails,
        objLoginParams = {
          WebLoginId,
          UserName: EmailOutside || Emailoutside,
          SessionId: SessionId,
        };
      if (
        (["RunScenario", "Ratesheetsignin", "ratelockleads"].includes(
          loginFrom
        ) ||
          ["DailyRates"].includes(Route)) &&
        logDetails["UserType"] === "E"
      ) {
        if (["RunScenario", "ratelockleads"].includes(loginFrom)) {
          try {
            window.parent.fnLoadLoanSelection(objLoginParams);
          } catch (error) {
            window.top.fnLoadLoanSelection(objLoginParams);
          }
          return false;
        } else if (
          window.parent.glo_clicktype == 2 ||
          ["DailyRates"].includes(Route)
        ) {
          let URL = `../../../BorrowerApplication/Presentation/Webforms/DirectDefault.aspx?Skip=1&SessionId=${SessionId}&Route=${Route}`;
          try {
            window.parent.location.href = URL;
          } catch (e) {
            window.location.href = URL;
          }
        } else {
          try {
            window.parent.fnAssignRateSheetParams(objLoginParams);
          } catch (error) {
            window.top.fnAssignRateSheetParams(objLoginParams);
          }
        }
      } else if (loginFrom === "esign" || loginFrom === "chat") {
        if (loginFrom === "esign") handleEsignProcess(logDetails);
        if (loginFrom === "chat") handleChatProcess(logDetails);
      } else if (loginFrom === "ratequote") {
        setErrorMessage({
          text: (
            <CustomText style={{ color: "#888" }}>
              <ArrowSpinner />
              {"  "}
              Please wait while we are Creating the loan with this scenario...
            </CustomText>
          ),
          color: "#999",
          italic: false,
        });

        let LoginXML = logDetails["rateQuoteXML"];
        if (LoginXML) {
          const parser = new DOMParser();
          const xmlDoc = parser.parseFromString(LoginXML, "text/xml");
          LoginXML = xmlDoc.documentElement;
          LoginXML.querySelectorAll("Component row").forEach(function (row) {
            row.setAttribute("UserEmailID", credentials["userName"]);
          });
        }
        window.parent.document.querySelector("#hdnWebLoginId").value =
          logDetails["WebLoginId"];
        window.parent.$LIXD = LoginXML || "";
        window.parent.fnCreateSessionNew();
        window.parent.fnCreateLoanAndLock_publicpage_New("0");
        return;
      } else if (
        (((logDetails["URL"] || "")?.indexOf("GoDirect") !== -1 ||
          (logDetails["URL"] || "")?.indexOf("rates-wizard.php") !== -1 ||
          HomePage == 1) &&
          loginFrom !== "loginverify" &&
          loginFrom !== "loanapp" &&
          loginFrom !== "securedoc") ||
        (logDetails["URL"] || "")?.indexOf("SignUpWizard.aspx") !== -1
      ) {
        if (
          window.self !== window.top &&
          (loginFrom === "ratewizard" ||
            loginFrom === "loanapp" ||
            loginFrom === "securedoc") &&
          (logDetails["URL"] || "")?.indexOf("SignUpWizard.aspx") === -1
        ) {
          handleRateOptionsLogin(logDetails);
          return;
        } else {
          if (web) {
            let URL_ = handleUpdateSessionId(
              logDetails["URL"],
              logDetails["SessionId"]
            );
            if (
              (URL_?.indexOf("GoDirect") !== -1 ||
                getQueryString("From", "") === "LoanOfficerWebsite") &&
              [516595, 1, 99766, 3486].includes(logDetails["WebLoginId"])
            ) {
              let params = queryStringToObject(URL_);
              params = {
                ...{
                  userName: logDetails["UserDisplayName"],
                  SessionId: logDetails["SessionId"],

                  WebLoginId: logDetails["WebLoginId"],
                },
                ...params,
              };

              setContextDetails((prevContextDetails) => {
                return { ...prevContextDetails, ...params };
              });
              navigate("DashBoard", params);
            } else {
              try {
                window.parent.location.href = URL_;
              } catch (e) {
                window.location.href = URL_;
              }
            }
          } else {
            navigate("DashBoard", {
              userName: logDetails["UserDisplayName"],
              SessionId: logDetails["SessionId"],
              WebLoginId: logDetails["WebLoginId"],
            });
          }
        }
      } else if (loginFrom === "loginverify") {
        let strPackage =
            window.parent.document.getElementById("hdnPackage").value,
          RefType = window.parent.document.getElementById("hdntype").value,
          URL = "";
        if (RefType == "plaid") {
          // URL = `../../../BorrowerApplication/presentation/webforms/BankVerification.aspx?SessionId=${logDetails["SessionId"]}&uid=${strPackage}`;
          URL = `${window.location.origin}/GoDirect/index.html?SessionId=${logDetails["SessionId"]}&uid=${strPackage}&Path=Plaid&From=loginverify`;
          try {
            window.parent.location.href = URL;
          } catch (e) {
            window.location.href = URL;
          }
        }
      } else {
        //replacing the session with new session
        let { SessionId, UserType } = logDetails;
        handleAPI({
          name: "GetNextStepWeb",
          params: { SessionId: SessionId, username: "", IP: "::1" },
        }).then((response) => {
          response = JSON.parse(response)["Table"][0];
          let URL = response["Column1"];
          if (URL != "" && URL != null && URL != undefined) {
            //=====================

            URL = `${URL}&Skip=1`;
            if (UserType == "C") {
              // URL = `../../../BorrowerLanding/Presentation/Webforms/BorrowerWelcome.aspx?SessionId=${SessionId}&To=${loginFrom}`; //"BorrowerWelcome";

              URL = `${window.location.origin}/GoDirect/index.html?Path=DashBoard&SessionId=${SessionId}`;
            }

            if (UserType == "V" || UserType == "M")
              URL = `../../../esignpackage/index.html?SessionId=${SessionId}`;

            let StartLoanApp = getQueryString("StartLoanApp", "0");

            if (
              loginFrom == "securedoc" ||
              loginFrom == "loanapp" ||
              (loginFrom == "ratewizard" && StartLoanApp == 1)
            ) {
              // if (logDetails["AutoRedirect"]) {
              handleSecureDocLogin(0, 0, StartLoanApp, logDetails); //P
              return;
              // } else {
              //   URL = logDetails["URL"];
              // }
            }
            if (UserType === "E") {
              if (
                loginFrom != "esign" &&
                loginFrom != "chat" &&
                loginFrom != "ratequote"
              )
                if (logDetails["URL"]) {
                  URL = logDetails["URL"];
                }
            }

            let URL_ = handleUpdateSessionId(URL, logDetails["SessionId"]);
            try {
              window.parent.location.href = URL_;
            } catch (e) {
              window.location.href = URL_;
            }
            try {
              if (action === "changePassword") {
                window.opener.close();
              }
            } catch (error) {}
          }
        });
      }
    }
    handleClearState(); //Restting the screen
  };
  const handleRateOptionsLogin = (logDetails) => {
    let From = getQueryString("From", ""),
      RateQuoteId = getQueryString("RateQuoteId", "") || 0,
      PublicRateQuoteId = getQueryString("PublicRateQuoteId", "") || 0,
      StartLoanApp = getQueryString("StartLoanApp", "0"),
      RateOptions = getQueryString("RateOptions", "0"),
      LockThisRate = getQueryString("LockThisRate", "0"),
      HomePage = getQueryString("HomePage", "0"),
      URL = "",
      { SessionId, GatherId, LoanOfficerId } = logDetails;

    if (!From) From = "";
    if (!RateQuoteId) RateQuoteId = "0";
    if (!PublicRateQuoteId) PublicRateQuoteId = "0";
    try {
      if (!LoanOfficerId)
        LoanOfficerId =
          window.parent.document.getElementById("spnUserInfo").attributes.empnum
            .value || "1";
    } catch (e) {}

    if (!LoanOfficerId) LoanOfficerId = "1";

    if (StartLoanApp == 1) {
      //URL = `../../../BorrowerLanding/Presentation/Webforms/BorrowerWelcome.aspx?SessionId=${SessionId}&StartLoanApp=1&To=${loginFrom}`;

      URL = `${window.location.origin}/GoDirect/index.html?Path=DashBoard&SessionId=${SessionId}&StartLoanApp=1`;
    } else {
      if (HomePage == 1) {
        try {
          window.parent.glo_SessionId = SessionId;
          window.parent.fnCloseCampignModal();
          if (RateOptions == 1) {
            window.parent.fnTriggerFrameOptions(1);
          }
          if (LockThisRate == 1) {
            window.parent.fnTriggerFrameOptions(2);
          }
        } catch (e) {
          if (window.parent.ParentPage === "NewLoPage") {
            try {
              window.parent.glo_SessionId = SessionId;
              //   window.parent.glo_CloseLoginPage = true;
              //window.parent.fnCloseCampignModal();
              // if (RateOptions == 1) {
              //   window.parent.fnTriggerFrameOptions(1);
              // }
              if (LockThisRate == 1) {
                window?.parent?.document
                  ?.getElementById("btnLockThisIntRate")
                  ?.click();
              }
              return false;
            } catch (e) {}
          }
          return false;
        }
        return false;
      }

      URL = `../../../rates/rates-wizard.php?SessionId=${SessionId}&GatherId=0&From=${From}&LoanOfficerId=${LoanOfficerId}&${
        PublicRateQuoteId > 0
          ? `PublicRateQuoteId=${PublicRateQuoteId}`
          : `RateQuoteId=${RateQuoteId}`
      }`;
    }
    try {
      window.parent.location.href = URL;
    } catch (e) {
      window.location.href = URL;
    }
  };
  const handleUpdateSessionId = (url, SessionId) => {
    let url_ = url.split("?");
    let page = url_[0],
      queryString = url_[1];
    queryString = queryString.split("&");
    queryString = queryString
      .filter((item) => item.toLowerCase().indexOf("sessionid") === -1)
      .join("&");
    let url1 = `${page}?${queryString}&SessionId=${SessionId}`;
    return url1;
  };
  const handleCloseOtherSession = async (logDetails) => {
    await handleAPI({
      name: "CloseOtherSession",
      params: {
        WebLoginId: logDetails["WebLoginId"],
        SessionId: logDetails["SessionId"],
      },
    }).then((response) => {});
  };
  const handleLoginClick = (flag) => {
    //Login with password and Accesscode
    //---------- Access Code entering flow ----------//
    try {
      if (currentPage === "enterAccessCode") {
        setErrorMessage({ text: "" });

        let accessCode = parseInt(logInDetails["AccessCode"]);

        if (loginFrom === "RunScenario" && !accessCode) {
          accessCode = parseInt(credentials["DBAccessCode"]);
        }
        if (parseInt(credentials["AccessCode"]) === accessCode) {
          setProcessingStatus("validating");
          setLoginDetails({
            ...logInDetails,
            MaxPasscodeIncorrectLogin: 0,
          });
          if (
            Number(logInDetails["UsingSecpwd"]) === 0 &&
            Number(logInDetails["deviceIdExist"]) === 0
          ) {
            handleAPI({
              name: "SaveDeviceFingerPrintWebOnly",
              params: {
                Email:
                  logInDetails["EmailOutside"] || logInDetails["Emailoutside"],
                DeviceId: deviceId,
              },
            }).then((response) => {});
          }
          if (logInDetails["isForgotPassword"]) {
            //Showing Password set screen
            setHeaderText("~~~Set your password.");
            setCurrentPage(
              action === "changePassword" ? "newPassword" : "setPassword&Login"
            );
            return false;
          }
          //---------- resetting password expired flag ----------//
          handleAPI({
            name: "UpdatePasscode",
            params: {
              refId: logInDetails["WebLoginId"],
            },
          }).then((response) => {});
          //--------------------------------------------//
          //---------- If cell phone is not exist in the login then showing option to add ----------//
          if (
            (logInDetails["CellPhone"] === undefined ||
              logInDetails["CellPhone"] === null ||
              logInDetails["CellPhone"] === "") &&
            flag !== -1
          ) {
            setCurrentPage("addCellPhone");
            setHeaderText(
              "~~~Optional. Add a Cell Phone Number to your account."
            );
            setLoginDetails(logInDetails);
            return false;
          }

          if (hideSecureEmail && flag !== -1) {
            handleAPI({
              name: "SavePhoneToAccount",
              params: {
                WebLoginId: logInDetails["WebLoginId"],
                Phone: logInDetails["CellPhone"],
              },
            }).then((response) => {
              handleLoginClick(-1);
            });
            return false;
          }
          //--------------------------------------------//

          handleLogin(flag, logInDetails); //General login process
        }
        //Handling entering invalid access code
        else {
          setProcessingStatus(null);
          setErrorMessage({ text: "Invalid Access Code." });
          let MaxPasscodeIncorrectLogin =
            parseInt(logInDetails["MaxPasscodeIncorrectLogin"] || 0) + 1;
          setLoginDetails({
            ...logInDetails,
            MaxPasscodeIncorrectLogin: MaxPasscodeIncorrectLogin,
          });
          handleLogFailedLoginEvent("Invalid Access Code.");
          if (MaxPasscodeIncorrectLogin === 5) {
            setHeaderText(
              `2nd Notice. ~~~This Login attempt has been blocked. The maximum login attempts have been exceeded. We have ${
                credentials["userName"].indexOf("@") === -1 ? "Text" : "Emailed"
              } you an access code. Enter it below.`
            );
            handleLogFailedLoginEvent(
              `This Login attempt has been blocked. The maximum login attempts have been exceeded. We have ${
                credentials["userName"].indexOf("@") === -1 ? "Text" : "Emailed"
              } you an access code. Enter it below.`
            );
          }
          //Reached max limit then terminating the user
          if (MaxPasscodeIncorrectLogin > 10) {
            handleAPI({
              name: "TerminateUserAccount",
              params: {
                WebLoginId: logInDetails["WebLoginId"],
              },
            }).then((response) => {
              setIsTerminated(true);
              setHeaderText(
                "~~~This account is terminated. Contact your administrator or MakeMeAware@directcorp.com for assistance."
              );
            });
          }
        }
      }
      //Multiple active session
      else if (currentPage === "multiLogin" && flag === 1) {
        setErrorMessage({ text: "" });
        setProcessingStatus("proceeding");
        handleLogin(flag, logInDetails);
      }
      //Enter password flow
      else {
        if (handleUserNameValidation()) {
          if (credentials["userName"] === "")
            setErrorMessage({ text: "Invalid Username" });
          return false;
        }
        if (credentials["password"] === "") {
          setErrorMessage({ text: "Invalid Password" });
          return false;
        }
        setProcessingStatus("validating");
        //Validating the credention is correct or not
        handleAPI({
          name: "ValidateLoginWithEmailorPhone",
          params: {
            UserName: credentials["userName"],
            Password: credentials["password"],
            SessionId: logInDetails["SessionId"],
          },
        }).then((response) => {
          try {
            response = JSON.parse(response)["Table"][0]["Column1"].toString();
            let responseXML = response;
            response = new XMLParser().parseFromString(response)["children"][0][
              "attributes"
            ];

            response["SessionId"] = logInDetails["SessionId"];
            response["MultiLogin"] = response["MultiLoginModel"];
            response["WebLoginId"] = logInDetails["WebLoginId"];
            response[
              "UserDisplayName"
            ] = `${response["FirstName"]} ${response["LastName"]}`;
            if (!response["UserDisplayName"]?.trim())
              response["UserDisplayName"] = response["ADUserName"];
            if (loginFrom === "ratequote")
              response["rateQuoteXML"] = responseXML;

            response = { ...logInDetails, ...response };
            setLoginDetails(response);
            let { UserId } = response;
            //Invalid credentials
            if (UserId == 0) {
              setProcessingStatus(null);
              setErrorMessage({ text: "Invalid Username or Password." });
              handleLogFailedLoginEvent("Invalid Username or Password");

              // let MaxPasscodeIncorrectLogin =
              //   parseInt(logInDetails["MaxPasscodeIncorrectLogin"] || 0) + 1;
              // setLoginDetails({
              //   ...response,
              //   ...{
              //     MaxPasscodeIncorrectLogin: MaxPasscodeIncorrectLogin,
              //   },
              // });

              return false;
            }
            //Terminated User
            else if (UserId == -99) {
              setHeaderText(
                "~~~This account is terminated. Contact your administrator or MakeMeAware@directcorp.com for assistance."
              );
              handleLogFailedLoginEvent("This account is terminated.");
              setIsTerminated(true);
              setProcessingStatus(null);
              return false;
            }
            //Blocked User
            else if (UserId == -98) {
              handleLogFailedLoginEvent("This user account has been blocked");
              if (credentials["userName"].indexOf("@") !== -1)
                handleAccessCodeLogin(1);
              else handleAccessCodeLogin(2);
              // setErrorMessage({
              //   text: "This account is terminated. Contact your administrator or MakeMeAware@directcorp.com for assistance.",
              //   color: "#999",
              // });
              setErrorMessage({
                text: "",
              });
              setLoginDetails({
                ...response,
                AccountLocked: 1,
              });
              setProcessingStatus(null);
              return false;
            }
            //Missing Manditory Info.
            else if (UserId == -97) {
              handleLogFailedLoginEvent(
                "This user login is missing the required account information"
              );
              setErrorMessage({
                text: "This user login is missing the required account information. Please contact MakeMeAware@directcorp.com.",
                color: "#999",
              });
              setProcessingStatus(null);
              return false;
            }
            //Blocked User and sending Access code to user
            else if (UserId == -96) {
              handleLogFailedLoginEvent(
                "This Login attempt has been blocked. The maximum allowed login attempts has been exceeded"
              );
              // setErrorMessage({
              //   text: "This Login attempt has been blocked. The maximum allowed login attempts has been exceeded.",
              //   color: "#999",
              // });
              setErrorMessage({
                text: "",
              });
              let logDetails_ = { ...response, attemptExceed: 1 };
              setLoginDetails(logDetails_);
              if (credentials["userName"].indexOf("@") !== -1)
                handleAccessCodeLogin(1, logDetails_);
              else handleAccessCodeLogin(2, logDetails_);
              setProcessingStatus(null);
              return false;
            }
            //Blocked User
            else if (UserId == -95) {
              handleLogFailedLoginEvent("This user account has been blocked.");
              setErrorMessage({
                text: "This user account has been blocked. To Unblock this login, please contact MakeMeAware@directcorp.com.",
                color: "#999",
              });
              setProcessingStatus(null);
              return false;
            }
            if (
              Number(response["UsingSecpwd"]) === 0 &&
              Number(response["deviceIdExist"]) === 0
            ) {
              let msg = `${
                response["UserDisplayName"]
              }--We recognize you, just not this specific device. We've ${
                credentials["userName"].indexOf("@") === -1 ? "Text" : "Emailed"
              } you an access code just to verify it's really you. Enter it below.`;

              if (credentials["userName"].indexOf("@") !== -1)
                handleAccessCodeLogin(1, response, msg);
              else handleAccessCodeLogin(2, response, msg);
              setProcessingStatus(null);
              return false;
            }

            //Valid credential - redirectng to corresponding page

            handleLogin(flag, response);
          } catch (e) {
            handleLogFailedLoginEvent("Database error");
            Alert.alert(
              "Database error. Please try again or contact MakeMeAware@directcorp.com for additional assistance."
            );
            log("Error from ValidateLoginWithEmailorPhone ====> ", e);
          }
        });
      }
    } catch (error) {
      log("Error from handleLoginClick ====> ", error);
    }
  };
  const handleLogGAEventPasscode = () => {
    //Storing login event details for Manual process
    try {
      handleAPI({
        name: "fnLogGAEvent_passcode",
        params: {
          UserWebloginId: logInDetails["WebLoginId"],
          device: web ? "desktop" : "mobile",
          LO: 0,
          fromAction: handleGetEmailMethod() || "DWLogin",
          Prevpage: `${REDIRECT_URL}sitelogin`, //"Mobile Application",
        },
      }).then((response) => {});
    } catch (error) {
      log("Error from handleLogGAEventPasscode ====> ", error);
    }
  };
  const handleGetEmailMethod = () => {
    let emailmethod = "DWLogin";
    if (
      document.documentURI.indexOf("StartLoanApp=1") !== -1 ||
      document.documentURI.indexOf("To=loanapp") !== -1
    )
      emailmethod = "StartLoanApp";
    else if (document.documentURI.indexOf("LockThisRate=1") !== -1)
      emailmethod = "LockThisIntRate";
    else if (document.documentURI.indexOf("RateOptions=1") !== -1)
      emailmethod = "RateOptions";
    else if (document.documentURI.indexOf("CustomizeOptions=1") !== -1)
      emailmethod = "CustomizeOptions";
    else if (document.documentURI.indexOf("To=ratequote") !== -1) {
      emailmethod = "RateQuotes";
    } else if (document.documentURI.indexOf("To=securedoc") !== -1) {
      emailmethod = "UploadDocs";
    }
    return emailmethod;
  };
  const handleLogAutoGAEventPasscode = (LO, WebLoginId) => {
    //Storing login event details for Auto redirecting process

    if (document.documentURI.indexOf("To=ratequote") !== -1) {
      LO = window?.parent?.getQuerystring("empnum", "");
    } else if (document.documentURI.indexOf("To=securedoc") !== -1) {
      LO = getQuerystring_document("loanofficer=", "0");
    }
    let device = web ? "desktop" : "mobile";
    try {
      handleAPI({
        name: "LogGAEvent",
        params: {
          UserWebloginId: WebLoginId || logInDetails["WebLoginId"],
          device: device,
          LO: LO || 0,
          fromAction: handleGetEmailMethod() || "DWLogin",
          Prevpage: `${REDIRECT_URL}sitelogin`, //"Mobile Application",
        },
      }).then((response) => {});
    } catch (error) {
      log("Error from handleLogAutoGAEventPasscode ====> ", error);
    }
  };
  const getQuerystring_document = (key, default_) => {
    let finalQueryString = "";
    if (default_ == null) default_ = "";
    key = key.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");

    let NewKey = key.toUpperCase();
    NewKey = NewKey.replace("=", "");
    let regex = new RegExp("[\\?&]" + NewKey + "=([^&#]*)"),
      ActualQueryString = window.location?.href || null,
      NewQueryString = ActualQueryString.toUpperCase(),
      qsValue = regex.exec(NewQueryString);
    if (qsValue != null) {
      let startPosi = NewQueryString.indexOf("&" + NewKey),
        keylen = NewKey.length,
        Querylen = ActualQueryString.length,
        prefix = ActualQueryString.substring(0, startPosi),
        sufix = ActualQueryString.substring(startPosi + 1 + keylen, Querylen);
      finalQueryString = prefix + "&" + NewKey + sufix;
    } else {
      finalQueryString = NewQueryString;
    }
    let qs = regex.exec(finalQueryString);
    if (qs == null) return default_;
    else return qs[1];
  };
  const handleLogFailedLoginEvent = async (Errmsg) => {
    //Storing login failed event details like invalid,Terminated login,etc...
    let strobj = {
      UserName: credentials["userName"],
      device: web ? "desktop" : "mobile",
      Errmsg: Errmsg,
      IPAddress: deviceId || "",
      emailmethod: handleGetEmailMethod() || "DWLogin",
      LO: 0,
      PrevPage: `${REDIRECT_URL}sitelogin`, //"Mobile Application",
    };
    try {
      handleAPI({
        name: "LogFailedLoginEvent",
        params: strobj,
      }).then((response) => {});
    } catch (error) {
      log("Error from handleLogFailedLoginEvent ====> ", error);
    }
  };
  const handleCreateNewAccClick = () => {
    //Create New accout flow
    if (credentials["userName"] === "") {
      setHeaderText(
        "~~~Let's create an account. Begin by entering a cell phone number or email address."
      );
      setErrorMessage({ text: "" });
      return false;
    }
    //Checking the user already exist or not
    handleAPI({
      name: "GetUserNameExists",
      params: { userName: credentials["userName"] },
    }).then((response) => {
      response = JSON.parse(response)["Table"][0];
      response = { ...logInDetails, ...response };
      setLoginDetails(response);
      if (parseInt(response["UserExists"]) === 1) {
        //User exist - next screen to login
        setCurrentPage("emailOnly");
        setHeaderText(`~~~Let's get you logged in...`);
      } else if (parseInt(response["UserExists"]) === 0) {
        //User not exist - Navigate to signup screen
        navigate("Signup", {
          userName: credentials["userName"],
          deviceId: deviceId,
        });
        handleClearState(); //Resetting the screen
      }
    });
  };
  const getSecureEmail = () => {
    //Showing Email like -> test.....@gmail.cm
    let Email =
      logInDetails["EmailOutside"] ||
      logInDetails["EmailOutside"] ||
      logInDetails["UserName"];
    //Hide emial when cell phone adding optoion
    if (hideSecureEmail) return <></>;
    if (
      credentials["userName"] === "" ||
      credentials["userName"].indexOf("@") === -1
    ) {
      if (Email !== undefined) Email = Email.split("@");
      else return <></>;
    } else Email = credentials["userName"].split("@");
    return (
      <>
        <CustomText
          onPress={() => {
            handleAccessCodeLogin(1);
          }}
          bold={true}
          style={[styles.footText, { alignSelf: "flex-start", fontSize: 13 }]}
        >
          Resend via email
        </CustomText>
        <CustomText
          bold={true}
          style={{ fontSize: 13, color: "#999", marginTop: 5 }}
        >
          {`${Email[0].slice(0, 2)}...${Email[1]}`}
        </CustomText>
        {[1, 3].includes(emailSentTo) && (
          <CustomText bold={true} style={{ color: "#0000ff", fontSize: 12 }}>
            Sent
          </CustomText>
        )}
      </>
    );
  };
  const getSecurePhone = () => {
    //Showing cellphone like -> xxx-xxx-8574
    let Phone = logInDetails["CellPhone"];
    if (Phone === undefined) {
      if (
        Number(credentials["userName"]) !== NaN &&
        credentials["userName"].indexOf("@") === -1
      ) {
        Phone = credentials["userName"];
      }
    } else Phone = Phone.slice(-4);
    return (
      <>
        {Phone === "" ? (
          <></>
        ) : (
          <>
            <CustomText
              onPress={() => {
                handleAccessCodeLogin(2);
              }}
              bold={true}
              style={[
                styles.footText,
                { alignSelf: "flex-start", fontSize: 13 },
              ]}
            >
              Resend via text message
            </CustomText>
            <CustomText
              bold={true}
              style={{
                fontSize: 13,
                color: "#999",
                marginTop: 5,
                alignSelf:
                  getQueryString("Mobile", "") == "true" ? "flex-end" : "",
              }}
            >
              {`xxx-xxx-${Phone}`}
            </CustomText>
            {[2, 3].includes(emailSentTo) && (
              <CustomText
                bold={true}
                style={{ color: "#0000ff", fontSize: 12 }}
              >
                Sent
              </CustomText>
            )}
          </>
        )}
      </>
    );
  };
  const handleCreateAccessCode = (WebLoginId, reff, logDetails) => {
    //Sending Access code to user for login,forgot password,etc...
    try {
      handleAPI({
        name: "CreateAccessCodeUsingWeblogin",
        params: { Id: WebLoginId, reff: reff },
      }).then((response) => {
        //For showing (Sent) text under the emial & cellphone
        response = JSON.parse(response)["Table"][0]["Column1"].toString();

        response = response.split("|");
        if (response.length > 2) {
          let msg = "";
          if (Number(response[3]) === 0) msg = response[1];
          setAccesscodeWarningMsg(msg);

          logDetails = {
            ...logDetails,
            ...{ AccessCode: response[2], isEnterAccessCode: true },
          };
          // console.log("Code ====> ", response[2]);
          logDetails = { ...logDetails, ...logInDetails };

          let userName = credentials["userName"] || logDetails["UserName"];
          logDetails[
            "rateQuoteXML"
          ] = `<Component><row WebLoginId="${WebLoginId}" SessionId="" UserEmailID="${userName}"/></Component>`;

          setLoginDetails(logDetails);
          handleGetNextStepWeb(logDetails);
          if (loginFrom === "RunScenario") {
            setCredentials((prevCredentials) => {
              return { ...prevCredentials, DBAccessCode: response[2] };
            });
          }
        }
      });
    } catch (error) {
      log("Error from handleCreateAccessCode ====> ", error);
    }
  };
  const handleAccessCodeLogin = (reff, logDetails, msg) => {
    //Pre- sete of access code sending process
    logDetails = { ...logInDetails, ...logDetails };
    let WebLoginId = logDetails["WebLoginId"];
    try {
      logDetails = logDetails || [];
      msg = msg || "";
      if (!logDetails["AutoRedirectCheck"]) {
        if (handleUserNameValidation()) {
          setErrorMessage({
            color: "#999",
            text: "This is not a valid username. Please enter a valid username to use the Forgot Password function.",
            italic: false,
          });
          return false;
        }
      }
      setLoginDetails({ ...logInDetails, ...logDetails });
      //Getting weblogin details is not exist already
      if (WebLoginId == undefined) {
        handleAPI({
          name: "GetUserNameExists",
          params: { userName: credentials["userName"] },
        }).then((response) => {
          response = JSON.parse(response)["Table"][0];
          WebLoginId = response["WebLoginId"];

          if (parseInt(response["UserExists"]) === 0) {
            //User not exist - Navigate to signup screen
            navigate("Signup", {
              userName: credentials["userName"],
              deviceId: deviceId,
            });
            handleClearState(); //Resetting the screen
            return;
          }
          logDetails = { ...logDetails, ...response, ...logInDetails };
          setLoginDetails(logDetails);
          logDetails = handleSetAccessCodeHeader(logDetails, msg, reff);
          handleEmailSentTo(reff);
          handleCreateAccessCode(WebLoginId, reff, logDetails);
          return false;
        });
      } else {
        logDetails = { ...logDetails, ...logInDetails };
        logDetails = handleSetAccessCodeHeader(logDetails, msg, reff);
        handleEmailSentTo(reff);
        handleCreateAccessCode(WebLoginId, reff, logDetails);
      }
    } catch (error) {
      log("Error form handleAccessCodeLogin ====> ", error);
    }
  };
  const handleSetAccessCodeHeader = (logDetails, msg, reff) => {
    msg = msg || "";

    if (logDetails["AccountLocked"] === 1) {
      logDetails = { ...logInDetails, isValidateAccesscode: true };
      msg = "This user account is locked. ";
      msg += `We've ${
        reff === 1 ? "Emailed" : "Text"
      } you an access code!\nEnter it below.`;
      setErrorMessage({ text: "" });
    } else if (logDetails["attemptExceed"] === 1) {
      logDetails = { ...logInDetails, isValidateAccesscode: true };
      if (logDetails["MaxPasscodeIncorrectLogin"] === 5) {
        msg = `2nd Notice. ~~~This Login attempt has been blocked. The maximum login attempts have been exceeded.`;
      } else {
        msg = `~~~This Login attempt has been blocked. ~~~The maximum login attempts have been exceeded.`;
      }
      msg += `We've ${
        reff === 1 ? "Emailed" : "Text"
      } you an access code!\nEnter it below.`;
    }

    setCurrentPage("enterAccessCode");
    if (loginFrom === "RunScenario") {
      const { CellPhone = "", EmailOutside, Emailoutside } = logDetails;
      const msg =
        CellPhone && (EmailOutside || Emailoutside)
          ? `Welcome <b style='color:black; font-weight:bold'>${logDetails["UserDisplayName"]}.</b>Run your own scenario. We've Emailed and Texted you an access code just to verify it's really you. Enter it below.`
          : `Welcome <b style='color:black; font-weight:bold'>${
              logDetails["UserDisplayName"]
            }.</b>Run your own scenario. We've ${
              emailId.indexOf("@") === -1 ? "Text" : "Emailed"
            } you an access code just to verify it's really you. Enter it below.`;

      setHeaderText("~~~" + msg);
    } else {
      setHeaderText(
        "~~~" +
          (msg ||
            `We've sent you ${
              reff === 1 ? "an Email" : "a Text"
            } with an access code!\nEnter it below.`)
      );
    }
    return logDetails;
  };

  const handleLogInValidation = () => {
    setAccesscodeWarningMsg("");
    setDisabledButton("loginValidate");
    handleLoginClick();
  };

  const getExpireDate = (expireInMinutes) => {
    //Getting expired time
    const now = new Date();
    let expireTime = new Date(now);
    expireTime.setMinutes(now.getMinutes() + expireInMinutes);
    return expireTime.getTime();
  };
  const getHeaderText = () => {
    //Showing the header text
    let header = headerText.replaceAll("~~~~~~", "");
    header = header.split("~~~");
    if (header[1].indexOf("--") > -1) {
      let header_ = header[1].split("--");
      header[1] = (
        <>
          <View style={{ width: "100%" }}>
            <CustomText
              bold={true}
              style={[
                styles.headText,
                {
                  color: isTerminated ? "red" : "#999",
                  fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
                  lineHeight: 22,
                  marginBottom: 5,
                  fontSize: 19,
                },
              ]}
            >
              {header_[0]}
            </CustomText>
          </View>
          <CustomText
            // bold={true}
            style={[
              styles.headText,
              {
                color: isTerminated ? "red" : "#999",
                fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
                lineHeight: 22,
                fontSize: 17,
              },
            ]}
          >
            {header_[1]}
          </CustomText>
        </>
      );
    } else if (header[1].indexOf("</b>") > -1) {
      let header_ = header[1]
        .replaceAll(`<b style='color:black; font-weight:bold'>`, "~")
        .replaceAll("</b>", "~");
      header_ = header_.split("~");
      header[1] = (
        <>
          {header_[0]}
          <b style={{ color: "black", fontWeight: "bold" }}>{header_[1]}</b>
          {"\n"}
          {header_[2]}
        </>
      );
    }

    return (
      <>
        <CustomText
          bold={true}
          style={[
            styles.headText,
            {
              color: isTerminated ? "red" : "#999",
              fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
              lineHeight: 22,
            },
          ]}
        >
          {header[0] !== "" ? (
            <CustomText bold={true} style={[styles.headText, { color: "red" }]}>
              {header[0]}{" "}
            </CustomText>
          ) : (
            <></>
          )}

          {header[1]}
        </CustomText>
      </>
    );
  };
  const validatePassword = (key, text) => {
    setPasswordMisMatch("");
    setNewPassword({ ...newPassword, ...{ [key]: text, key: key } });
  };
  const navigate = async (navigateTo, navigateDetails) => {
    let details = { ...navigateDetails, navigation: navigation };
    setContextDetails((prevContextDetails) => {
      return { ...prevContextDetails, ...details };
    });

    if (navigateTo === "DashBoard") {
      let url = await updateWebURL(
        { ...navigateDetails, Path: navigateTo },
        true
      );
      // window.top.location.href = `${window.location.origin}${
      //   window.location.host === "localhost:19006"
      //     ? ""
      //     : "/GoDirect/index.html?"
      // }${url}`;
      try {
        window.top.location.href = `${window.location.origin}/GoDirect/index.html?${url}`;
      } catch (error) {
        window.location.href = `${window.location.origin}/GoDirect/index.html?${url}`;
      }
    } else {
      updateWebURL({ ...navigateDetails, Path: navigateTo });
      (navigation || props["navigation"]).navigate(navigateTo, navigateDetails); // Sample ===> "signUp",{}
    }
  };

  const handleLogDWCallToActionEventParent = async (iButtontext, emailId) => {
    let PageLoadId =
      window?.parent?.GLO_PageLoadId ||
      (await AsyncStorage.getItem("PageLoadId")) ||
      0;
    let device = web ? "desktop" : "mobile",
      Buttontext = iButtontext || handleGetButtonText(loginFrom);

    let params = {
      PageTitle: window.parent.document.title,
      PageURL: window.parent.location.href,
      device,
      IPAddress: window.parent.GloParentDeviceId,
      ParentId: web
        ? window?.parent?.GLO_PageLoadId || PageLoadId || 0
        : PageLoadId || 0,
      Buttontext,
      detailsJson: JSON.stringify([
        {
          Browser: handleGetBrowserName(),
          LoanId: 0,
          LoanOfficerId: web
            ? queryStringToObject(window.location?.href || "")[
                "loanOfficerId"
              ] ||
              contextDetails.RecentLoId ||
              0
            : contextDetails.RecentLoId || 0,
          Email:
            emailId ||
            logInDetails["EmailOutside"] ||
            logInDetails["Emailoutside"] ||
            "",
        },
      ]),
    };
    if (Buttontext !== "") {
      await handleAPI({
        name: "fnLogDWCallToActionEvent", // Contact_Sp_DWLog_CallToActions
        params,
      })
        .then(async (response) => {
          await handleTrackGA4Events(Buttontext, params);
        })
        .catch((e) => log("Error form fnLogDWCallToActionEvent ====> ", e));
    }
  };
  const handleGetNewDeviceId = async () => {
    let iDeviceId = null,
      iVisitorId = window.parent?.GloParentDeviceId;
    if (deviceId) iDeviceId = deviceId;
    else {
      if (!iVisitorId) {
        try {
          const fp = await FingerprintJS.load({
            token: "gRFbO46GhIYEf0AI5z16",
          });
          const { visitorId } = await fp.get();
          iDeviceId = visitorId;
        } catch (error) {}
      }
      iVisitorId = iVisitorId || iDeviceId;
      AsyncStorage.setItem("DeviceId", JSON.stringify(iVisitorId) || null);
    }
    if (!iVisitorId) {
      // let randomString = require("randomstring");
      // iVisitorId = randomString.generate(20);
      // iVisitorId = JSON.stringify(iVisitorId);
      iVisitorId = generateFingerprint();
      iVisitorId = JSON.stringify(`D-${iVisitorId.replaceAll("-", "")}`);
      await AsyncStorage.setItem("DeviceId", iVisitorId || null);
    }

    // console.log("Your GloParentDeviceId ====> ", iVisitorId);
    return iVisitorId;
  };

  const handleLogDWVisitorsEvent = async (visitorId) => {
    let params = {
      PageTitle: "Login",
      PageURL: web
        ? window?.parent?.location.href || window.location.href
        : "GoDirect Loan Application",
      device: web ? "desktop" : "mobile",
      IPAddress:
        window.parent?.GloParentDeviceId ||
        visitorId ||
        (await handleGetNewDeviceId()),
      ParentId: window?.parent?.GLO_PageLoadId || 0,
      detailsJson: JSON.stringify([
        {
          Browser: handleGetBrowserName(),
          LoanId: 0,
        },
      ]),
    };
    await handleAPI({
      name: "LogDWVisitorsEvent",
      params,
    }).then((PageLoadId) => {
      AsyncStorage.setItem(
        "iPageLoadId",
        JSON.stringify(window?.parent?.GLO_PageLoadId || PageLoadId || null)
      );
      handleTrackGA4Events("LogIn", params);
      return PageLoadId;
    });
  };
  const handleStoreCampaignDetails = (
    logDetails,
    CampignId,
    utm_campaign,
    CampignNum
  ) => {
    let utm_source = "Direct Mortgage",
      utm_medium = "Internal",
      utm_content = "",
      utm_term = "",
      OrgUrl = window.top.document.location.href,
      msgtext = "",
      LOId = 0,
      WebLoginId = 4142;
    if (OrgUrl == null || OrgUrl == undefined) {
      OrgUrl = "";
    }
    if (
      loginFrom == "securedoc" ||
      loginFrom == "loanapp" ||
      loginFrom == "ratequote"
    ) {
      try {
        if (LOId == 0 || LOId == null || LOId == "" || LOId == undefined) {
          LOId = window?.parent?.getQuerystring("loanofficer", "");
        }
      } catch (e) {}
    }
    if (LOId == "0" || LOId == null || LOId == "" || LOId == undefined)
      LOId = "1";

    if (
      (logDetails["WebLoginId"] != "") & (logDetails["WebLoginId"] != null) &&
      logDetails["WebLoginId"] != undefined
    ) {
      WebLoginId = logDetails["WebLoginId"];
    }

    try {
      handleAPI({
        name: "StoreUTMCampaignWithOutLoginId",
        params: {
          CampignId,
          WebLoginId,
          utmsource: utm_source,
          utmmedium: utm_medium,
          utmcampaign: utm_campaign,
          utmcontent: utm_content,
          utmterm: utm_term,
          OrgUrl,
          MsgText: msgtext,
          Email:
            logInDetails["Emailoutside"] || logInDetails["EmailOutside"] || "",
          Phone: logInDetails["cellPhone"] || "",
          CampignNum,
          LeadOfficer,
        },
      }).then((response) => {
        // console.log("StoreUTMCampaignWithOutLoginId", response);
      });
    } catch (e) {
      console.error(e);
    }
  };
  function handleUpdateIISSession(SessionId) {
    let iframe = document.getElementById("IISSessionFrame"),
      // IISSessionId = "",
      IISSessionIdASP = "";
    if (iframe) {
      let iframeDoc = iframe.contentDocument || iframe.contentWindow.document,
        // IISSessionEle = iframeDoc.getElementById("hdnIISSessionId"),
        IISSessionIdASPEle = iframeDoc.getElementById("hdnIISSessionIdASP1");
      // if (IISSessionEle) IISSessionId = IISSessionEle.value;
      if (IISSessionIdASPEle) IISSessionIdASP = IISSessionIdASPEle.value;
      else IISSessionIdASP = handleGetASPId();
    } else {
      IISSessionIdASP = handleGetASPId();
    }
    handleAPI({
      name: "updateIISaspSession", //"UpdateIISSessionId",
      params: {
        SessionId: SessionId,
        IISSessionId: IISSessionId || handleGetIISid() || "",
        IISSessionIdASP: IISSessionIdASP || "",
      },
    })
      .then((response) => {
        console.log("updateIISaspSession", response);
      })
      .catch((e) => console.error(e));
  }
  function handleGetIISid() {
    let iframe = document.getElementById("IISSessionWrapper"),
      IISSessionId = "";
    if (iframe) {
      let iframeDoc = iframe.contentDocument || iframe.contentWindow.document,
        IISSessionEle = iframeDoc.getElementById("hdnIISSessionId");

      if (IISSessionEle) IISSessionId = IISSessionEle.value;
    }
    return IISSessionId || "";
  }

  const handleGetASPId = () => {
    let aspId = document.cookie
      .split("; ")
      .filter((item) => item.indexOf("CookieSessionID") > -1);
    if (aspId.length > 0) return aspId[0].split("=")[1];
    return "";
  };
  const handleCreateSessionWebLoginWrapper = (logDetails) => {
    if (window.self !== window.top) {
      handleCreateSessionWebLogin(logDetails);
    } else {
      setTimeout(
        () => {
          handleCreateSessionWebLogin(logDetails);
        },
        logDetails["AutoRedirect"] ? 1000 : 0
      );
    }
  };
  const Frame = memo(() => {
    if (web) {
      try {
        return (
          <>
            <iframe
              id="IISSessionFrame"
              src="/IISSessionId.asp"
              style={{ display: "none" }}
            />
            <iframe
              id="IISSessionWrapper"
              src="/Login/presentation/webforms/IISSessionWrapper.aspx"
              style={{ display: "none" }}
            />
          </>
        );
      } catch (error) {
        return <></>;
      }
    }
    return <></>;
  });
  //--------------------fEnd------------------------//
  //---------- handling password setting - validation and messages ----------//
  useEffect(() => handleSetEmailId(true), [emailId]);

  const handleSetEmailId = (isInitiateLogin) => {
    if (emailId) {
      setCredentials((prevCredentials) => {
        return { ...prevCredentials, userName: emailId, isInitiateLogin };
      });
    }
  };

  useEffect(() => {
    if (action === "changePassword" && emailId) {
      handleForgotPassword();
    }
  }, [credentials["userName"]]);
  const handleForgotPassword = () => {
    isForgotPassword = true;

    setErrorMessage({ text: "" });
    if (credentials["userName"].indexOf("@") !== -1)
      handleAccessCodeLogin(1, {
        isForgotPassword: true,
      });
    else
      handleAccessCodeLogin(2, {
        isForgotPassword: true,
      });
  };
  useEffect(() => {
    if (credentials["isInitiateLogin"]) {
      // handleNextClick(false, emailId);
      setCredentials((prevCredentials) => {
        return {
          ...prevCredentials,
          userName: emailId,
          isInitiateLogin: false,
          existingFlowRunScenario: true,
        };
      });
    }
  }, [credentials["isInitiateLogin"]]);

  useEffect(() => {
    let strength = 0,
      key = newPassword["key"],
      text = newPassword[key];
    if (text !== undefined) {
      if (text.length > 6) strength += 1;
      if (text.match(/([A-Z])/) && text.match(/([0-9])/)) strength += 1;
      if (text.match(/([!,%,&,@,#,jQuery,^,*,?,_,~])/)) strength += 1;
      let msg = ``;
      if (strength < 3) {
        msg = `Password does not meet complexity Requirements.`;
      } else {
        msg = `Password Meets Complexity Requirements`;
      }
      if (key === "confirmPassword" && text !== newPassword["password"]) {
        msg = `Password Does Not Match`;
        strength = 0;
      }
      if (
        (newPassword["password"] === "" && key === "password") ||
        (newPassword["confirmPassword"] === "" && key === "confirmPassword")
      ) {
        msg = "";
      } else {
        msg = (
          <View style={{ marginTop: -10, marginBottom: 10 }}>
            <FontAwesome
              name={strength < 3 ? "close" : "check"}
              size={22}
              color={strength < 3 ? "red" : "green"}
            />
            <CustomText
              bold={true}
              style={{
                color: "#999",
                marginTop: -20,
                marginBottom: 20,
                fontSize: 14,
                marginLeft: 30,
              }}
            >
              {msg}
            </CustomText>
          </View>
        );
      }
      setnewPasswordMessage({ ...newPasswordMessage, [`${key}Msg`]: msg });
    }
  }, [newPassword]);
  //--------------------------------------------//

  //---------- Auto redirecting process and getting Visitor id ----------//
  useEffect(() => {
    setIsPasswordSecure(true);
    let logDetails = {},
      CampaignPage = 0,
      CampaignInline = "";

    const getDeviceId = async () => {
      setDeviceId(await handleGetNewDeviceId());
    };
    async function prepare() {
      try {
        window.parent.document.getElementById("divCampaignModal").style.top =
          "20%";
        window.parent.document.querySelector(
          "#divCampaignModal .modal-dialog"
        ).style.width = "500px";

        if (
          window.parent.CampaignPage !== null &&
          window.parent.CampaignPage === 1
        )
          CampaignPage = 1;

        CampaignInline = getQueryString("campaigninline", 0);
        setLoginDetails({
          ...logInDetails,
          ...{ CampaignPage, CampaignInline },
        });
      } catch (error) {}

      try {
        if (loginFrom === "ratequote") {
          window.parent.document.getElementById("iframeLogin").style.height =
            "600px";
        }
      } catch (error) {}

      // try {
      //   await SplashScreen.preventAutoHideAsync();
      //   await new Promise((resolve) => setTimeout(resolve, 20));
      // } catch (e) {
      //   console.warn(e);
      // } finally {

      setAppIsReady(true);
      let result = (await handleGetStoredCredential()) || {};
      if (result["AutoRedirect"]) {
        logDetails = { ...result, ...logInDetails };
        // debugger;
        if (logDetails["URL"] && logDetails["URL"].includes("esignpackage")) {
          if (loginFrom != "esign") {
            if (logDetails["UserType"] == "E")
              logDetails["URL"] =
                "../../../BorrowerApplication/Presentation/Webforms/DirectDefault.aspx?Skip=1&SessionId=";
            else if (logDetails["UserType"] == "C")
              logDetails["URL"] =
                " ../../../GoDirect/index.html?Path=DashBoard&SessionId=";
          }
        }

        setIsRemember(true);
        logDetails = { ...logDetails, ...logInDetails };
        // setLoginDetails(logDetails);
        const { UserDisplayName, loginName } = result;

        setHeaderText(
          `~~~Welcome Back ${
            UserDisplayName || loginName || ""
          }--We're logging you in...`
        );
      } else {
        setCurrentPage("emailOnly");
      }
      // }
      //Visitor Id generator

      let visitorIdOld = await AsyncStorage.getItem("DeviceId"),
        // let visitorIdOld = await cookies["DeviceId"],
        visitorId = null;

      try {
        visitorIdOld = JSON.parse(visitorIdOld);
      } catch (error) {
        visitorIdOld = visitorIdOld;
      }

      if (visitorIdOld) {
        visitorId = visitorIdOld;
      } else {
        visitorId = await handleGetNewDeviceId();
      }
      // visitorId = JSON.parse(visitorId);
      setDeviceId(visitorId || "");
      logDetails["DeviceId"] = visitorId;
      let parentURL;
      try {
        parentURL = window.parent.location.href.toString();
      } catch (e) {
        parentURL = window.location.href.toString();
      }
      let Eventrecorded = 0,
        PriorPage = window.parent.document.referrer.toString(),
        lowerParentURL = parentURL.toLowerCase(),
        includesParentURL = parentURL.includes.bind(parentURL),
        IsSiteLogin = 0,
        RegularLogin = 0,
        PageLoadId = 0;

      if (PriorPage === "" && !parentURL.includes("/LoginInline.aspx")) {
        PageLoadId = handleLogDWVisitorsEvent(visitorId);
        handleLogDWCallToActionEventParent();
        Eventrecorded = 1;
      }

      if (
        lowerParentURL.toLowerCase().includes("/sitelogin") || //1
        lowerParentURL.toLowerCase().includes("/court") || //1
        includesParentURL("/courtlogintest") ||
        includesParentURL("/sitelogintest") ||
        includesParentURL("/wholesalelogin") || //1
        includesParentURL("/default.asp") || //1
        includesParentURL("/SecureDocLogin.aspx") || //1
        includesParentURL("/securedoc") || //1
        includesParentURL("/LoanApplicationNew.aspx") || //1
        includesParentURL("/loginverify.aspx") || //1
        includesParentURL("/signup") || //1
        getQueryString("From", "") === "LoanOfficerWebsite" || //1
        CampaignPage === 1 ||
        loginFrom === "ratewizard"
      ) {
        IsSiteLogin = 1;

        if (
          (loginFrom === "loanapp" ||
            lowerParentURL.includes("/sitelogin") ||
            loginFrom === "ratewizard") &&
          Eventrecorded === 0
        ) {
          handleLogDWCallToActionEventParent();
        }
      }

      if (
        lowerParentURL.toLowerCase().includes("/sitelogin") ||
        includesParentURL("/default.asp")
      ) {
        RegularLogin = 1;
      }

      if (CampaignPage === 1 && CampaignInline === 1) {
        handleCreateNewAccClick();
        setHeaderText(`~~~${window.parent.glo_CampaignLoginHdrInline}`);
      }

      if (loginFrom === "employment") {
        try {
          let JobPos = getQueryString("JobPos", "");
          if (JobPos) {
            handleAPI({
              name: "GetJobDesc",
              params: { JobPos: JobPos },
            })
              .then((JobDesc) => {
                if (JobDesc != "") {
                  setHeaderText(
                    `~~~Apply to ${JobDesc} position. Enter your email address or cell phone number.`
                  );
                }
              })
              .catch((e) => console.error(e));
          }
        } catch (e) {
          // alert(e.Message);
        }
      }

      if (loginFrom === "loginverify")
        try {
          let uniqueid = window.parent.getQuerystring("id");

          if (uniqueid) {
            await handleAPI({
              name: "GetPlaidLoginDetails",
              params: { Id: uniqueid },
            })
              .then((response) => {
                let result = response.split("~");
                let username = result[0];
                let email = result[1];

                setCredentials({
                  ...credentials,
                  formattedUserName: email,
                  userName: email,
                });

                setHeaderText(
                  `~~~Welcome back <b style='color:black; font-weight:bold'>${
                    username || ""
                  }.</b>
Verify your bank and employment information here. Get started by entering your email address or your cell phone number.

If you are unfamiliar with this request, please call your loan officer.`
                );
              })
              .catch((e) => console.error(e));
          } else {
            setHeaderText(
              "~~~Verify your bank and employment information here. Get started by entering your email address or your cell phone number."
            );
          }
        } catch (e) {
          setHeaderText(
            "~~~Verify your bank and employment information here. Get started by entering your email address or your cell phone number."
          );
        }

      let UserWebLoginId = logDetails["WebLoginId"],
        UserDisplayName = logDetails["UserDisplayName"],
        AutoRedirect = false;
      logDetails = { ...logDetails, ...logInDetails };
      if (CampaignPage == 0) {
        if (
          UserWebLoginId != "" &&
          UserWebLoginId != null &&
          UserWebLoginId != undefined &&
          UserWebLoginId != "0"
        ) {
          AutoRedirect = true;

          if (loginFrom == "ratequote") {
            window.parent.document.getElementById("hdnWebLoginId").value =
              UserWebLoginId;
            let LoanOfficerId = window?.parent?.getQuerystring("empnum", ""),
              LoginXML = `<Component><row WebLoginId="${UserWebLoginId}" SessionId="" UserEmailID="${logDetails["UserName"]}"/></Component>`,
              parser = new DOMParser();
            window.parent.$LIXD = parser.parseFromString(LoginXML, "text/xml");
            handleLogAutoGAEventPasscode(LoanOfficerId, UserWebLoginId);
            handleStoreCampaignDetails(
              { ...logDetails, ...logInDetails },
              201,
              "Rate Quote",
              11
            );
            window.parent.fnCreateSessionNew();
            window.parent.fnCreateLoanAndLock_publicpage_New("0");
            return;
          }

          let AutoRedirectExpiryDate = logDetails["AutoRedirectExpiryDate"];
          // AutoRedirectExpiryDate = 10;
          if (new Date().getTime() > Number(AutoRedirectExpiryDate)) {
            AutoRedirect = false;
            logDetails = {
              ...logDetails,
              ...logInDetails,
              ...{ UserExists: 1, AutoRedirectCheck: true, AutoRedirect },
            };
            handleCreateSessionWebLoginWrapper(logDetails);
            return;
          }
          if (
            UserDisplayName != "" &&
            UserDisplayName != null &&
            UserDisplayName != undefined
          ) {
            setHeaderText(
              `~~~Welcome Back ${UserDisplayName}--We're logging you in...`
            );
            logDetails = { ...logDetails, AutoRedirectCheck: true };
            handleCreateSessionWebLoginWrapper(logDetails);
          } else {
            logDetails = { ...logDetails, AutoRedirectCheck: true };
            handleCreateSessionWebLoginWrapper(logDetails);
          }
          return;
        }
      }
      if (CampaignPage == 1) {
        AutoRedirect = false;
      }
      logDetails = {
        ...logDetails,
        ...{
          IsSiteLogin,
          RegularLogin,
          PageLoadId,
          CampaignPage,
          CampaignInline,
          AutoRedirect,
        },
      };
      setLoginDetails({
        ...logInDetails,
        ...logDetails,
      });
    }

    getDeviceId();
    prepare();

    IISSession !== "" && setIISSessionId(IISSession);
  }, [props]);

  //--------------------------------------------//

  //---------- Creating new session when auto redirecting process  ----------//
  useEffect(() => {
    if (
      logInDetails["AutoRedirect"] &&
      logInDetails["AutoRedirectCheck"] === undefined
    ) {
      handleCreateSessionWebLogin(logInDetails);
    }
  }, [isRemember, logInDetails]);
  //--------------------------------------------//

  //---------- Showing splish screen when app loading ----------//
  // const onLayoutRootView = useCallback(async () => {
  //   if (appIsReady) await SplashScreen.hideAsync();
  // }, [appIsReady]);
  // if (!appIsReady) return <></>;
  //--------------------------------------------//

  return (
    <>
      {webPageURL ? (
        <>
          <WebPageView url={webPageURL} />
        </>
      ) : (
        <View
          style={[
            {
              backgroundColor:
                getQueryString("Route", "") === "dmloanapp"
                  ? "#f4f4f4"
                  : "#fff",
              flex: 1,
              flexShrink: 1,
            },
            // loginFrom === "esign" && {
            //   alignItems: "center",
            //   width: window.innerWidth,
            // },
          ]}
        >
          {(loginFrom === "esign" ||
            loginFrom === "chat" ||
            header === "1") && (
            <View
              style={{
                width: "100%",
                height: 85,
                boxShadow: "0 0 3px 0 rgba(0,0,0,0.22)",
                marginBottom: loginFrom === "esign" ? 50 : 20,
                display: getQueryString("HideHeader", "") === "1" ? "none" : "",
              }}
            >
              <TouchableOpacity
                activeOpacity={1}
                onPress={() => {
                  handleGoToHome();
                }}
              >
                <Image
                  style={{
                    position: "relative",
                    height: "50px",
                    width: "180px",
                    marginTop: 25,
                    marginBottom: 10,
                    marginLeft: 30,
                    cursor: "pointer",
                  }}
                  source={require("../../assets/logo.png")}
                />
              </TouchableOpacity>
              {loginFrom === "esign" && (
                <CustomText
                  bold={true}
                  style={{
                    color: "#999",
                    fontSize: isMobileWeb ? 21 : 27,
                    marginTop: 15,
                    marginBottom: 10,
                    marginLeft: 15,
                  }}
                >
                  Welcome to the E-Signature Page
                </CustomText>
              )}
            </View>
          )}
          <View
            // onLayout={onLayoutRootView}
            style={[
              {
                // isIOS || isAndroid
                // ? 420
                // width: !web
                //   ? null
                //   : getQueryString("Route", "") === "dmloanapp"
                //   ? "95%"
                //   : "inherit",
                // marginLeft: loginFrom === "loanapp" ? "1rem" : "",
                width: "95vw",
                marginLeft: 10,
              },
              web ? { maxWidth: 475 } : {},
              web &&
              getQueryString("From", "") === "LoanOfficerWebsite" &&
              getQueryString("Mobile", "") == undefined
                ? { maxWidth: 405 }
                : {},
              web &&
              getQueryString("From", "") === "LoanOfficerWebsite" &&
              getQueryString("Mobile", "") == "false"
                ? { maxWidth: 420 }
                : {},
              web &&
              getQueryString("From", "") === "LoanOfficerWebsite" &&
              getQueryString("Mobile", "") == "true"
                ? { maxWidth: 378 }
                : {},
            ]}
          >
            <ScrollContainer>
              <View
                style={[
                  styles.container,
                  !(window.self !== window.top) ? { marginTop: 10 } : {},
                ]}
              >
                {/* loginFrom === "esign"
                      ? {
                          boxShadow: "0 5px 15px rgba(0,0,0,.5)",
                          border: "1px solid #999",
                          marginTop: 10,
                          marginLeft: 15,
                          marginRight: 25,
                          marginBottom: 25,
                          width: "92%",
                        }
                      : */}
                <View style={styles.headContainer}>{getHeaderText()}</View>
                {!isTerminated && (
                  <>
                    <View style={styles.bodyContainer}>
                      {currentPage === "emailOnly" ||
                      currentPage === "loginOption" ||
                      currentPage === "enterPassword" ? (
                        <>
                          {!logInDetails["AutoRedirect"] && (
                            <View
                              style={{
                                flexDirection: "row",
                                margin: 10,
                                justifyContent: "space-between",
                                display:
                                  currentPage === "loginOption" ||
                                  currentPage === "enterPassword"
                                    ? "none"
                                    : "flex",
                              }}
                            >
                              <View
                                style={{
                                  flexShrink: 1,
                                  width: `${
                                    currentPage === "emailOnly" ? "80%" : "100%"
                                  }`,
                                }}
                                // style={{
                                //   width: "80%",

                                // }}
                              >
                                <InputBox
                                  label="Email or Cell Phone"
                                  autoFocus
                                  placeholder="Email or Cell Phone"
                                  disabled={
                                    (emailId &&
                                      !logInDetails["enableEmailField"]) ||
                                    logInDetails["AutoRedirect"]
                                  }
                                  onBlur={() => {
                                    if (credentials["userName"] !== "") {
                                      handleNextClick();
                                    }
                                  }}
                                  onChangeText={(text) => {
                                    if (Number(text)) setComplianceMsg(true);
                                    else setComplianceMsg(false);
                                    try {
                                      if (
                                        text === "" &&
                                        currentPage !== "emailOnly"
                                      ) {
                                        setCurrentPage("emailOnly");
                                        setLoginDetails({});
                                      }
                                      updateCredential({
                                        name: "userName",
                                        value: text,
                                      });
                                      setErrorMessage({ text: "" });
                                      setDisabledButton("");
                                    } catch (e) {
                                      log("Email or Cell Phone ====> ", e);
                                    }
                                  }}
                                  value={
                                    credentials["formattedUserName"] || emailId
                                  }
                                  validate={
                                    headerText.indexOf(
                                      `Let's create an account`
                                    ) !== -1 && credentials["userName"] === ""
                                  }
                                />
                              </View>
                              {currentPage === "emailOnly" && (
                                <>
                                  <IconButton
                                    style={{ marginLeft: 10 }}
                                    onPress={() => {
                                      if (emailId) {
                                        handleNextClick();
                                      } else handleNextClick(true);
                                    }}
                                    title="Next"
                                    loading={processingStatus === "Next"}
                                    sStyle={{
                                      minWidth: 30,
                                      height: 15,
                                    }}
                                  />
                                </>
                              )}
                            </View>
                          )}
                        </>
                      ) : null}
                      {currentPage === "enterPassword" && (
                        <View
                          style={{
                            marginHorizontal: 10,
                            marginBottom: 10,
                            marginTop: 12,
                          }}
                        >
                          <View>
                            <InputBox
                              label="Password"
                              autoFocus
                              secureTextEntry={isPasswordSecure}
                              placeholder="Password"
                              onChangeText={(text) => {
                                setErrorMessage({ text: "" });
                                setDisabledButton("");
                                updateCredential({
                                  name: "password",
                                  value: text,
                                });
                              }}
                              onKeyPress={(event) => {
                                if (event.nativeEvent.key === "Enter") {
                                  if (credentials["password"] !== "")
                                    handleLogInValidation();
                                }
                              }}
                              value={credentials["password"]}
                            />
                            <CustomText
                              style={{
                                position: "absolute",
                                right: 20,
                                top: 20,
                              }}
                              onPress={() => {
                                setIsPasswordSecure(!isPasswordSecure);
                              }}
                            >
                              {isPasswordSecure ? (
                                <FontAwesome
                                  name="eye"
                                  color="gray"
                                  size={15}
                                />
                              ) : (
                                <FontAwesome
                                  name="eye-slash"
                                  color="gray"
                                  size={15}
                                />
                              )}
                            </CustomText>
                          </View>
                        </View>
                      )}
                      {currentPage === "enterAccessCode" && (
                        <View style={{ margin: 10 }}>
                          <InputBox
                            label="Access Code"
                            autoFocus
                            keyboardType="numeric"
                            disable={disabledButton === "loginValidate"}
                            placeholder="Please enter your access code..."
                            onChangeText={(text) => {
                              updateCredential({
                                name: "AccessCode",
                                value: text,
                              });
                              setErrorMessage({ text: "" });
                              setDisabledButton("");
                            }}
                            value={credentials["AccessCode"]}
                            onKeyPress={(event) => {
                              if (event.nativeEvent.key === "Enter") {
                                if (credentials["AccessCode"] !== "")
                                  handleLogInValidation();
                              }
                            }}
                          />
                        </View>
                      )}
                      {currentPage === "loginOption" && (
                        <View
                          style={{
                            paddingBottom: 15,
                            paddingHorizontal: 5,
                            //flexDirection: isMobileWeb ? "column" : "row",
                            flexDirection: "row",
                            justifyContent: "space-around",
                            alignItems: "center",
                            marginTop: currentPage === "loginOption" ? 12 : -20,
                            //alignSelf: isMobileWeb ? "center" : "unset",
                            alignSelf: "unset",
                          }}
                        >
                          <IconButton
                            autoFocus={true}
                            onPress={(e) => {
                              if (
                                parseInt(logInDetails["AccountTerminated"]) ===
                                1
                              ) {
                                setHeaderText(
                                  "~~~This account is terminated. Contact your administrator or MakeMeAware@directcorp.com for assistance."
                                );
                                handleLogFailedLoginEvent(
                                  "This account is terminated."
                                );
                                setIsTerminated(true);
                                return false;
                              }
                              setCurrentPage("enterPassword");
                              setHeaderText(
                                "~~~Please enter your password below."
                              );
                            }}
                            title="Enter Password"
                          />
                          {/* <CustomText
                            style={{
                              color: "#999",
                              fontSize: 14,
                              verticalAlign: "middle",
                              fontWeight: "bold",
                            }}
                          >
                            or
                          </CustomText> */}
                          <IconButton
                            onPress={(e) => {
                              log("send me a code ====> ", logInDetails);
                              // return;
                              if (
                                parseInt(logInDetails["AccountTerminated"]) ===
                                1
                              ) {
                                setHeaderText(
                                  "~~~This account is terminated. Contact your administrator or MakeMeAware@directcorp.com for assistance."
                                );
                                handleLogFailedLoginEvent(
                                  "This account is terminated."
                                );
                                setIsTerminated(true);
                                return false;
                              }
                              if (credentials["userName"].indexOf("@") !== -1)
                                handleAccessCodeLogin(1);
                              else handleAccessCodeLogin(2);
                            }}
                            title="Send me a code"
                          />
                        </View>
                      )}

                      {/* {currentPage === "enterAccessCode" ||
                      currentPage === "enterPassword" ? (
                        <>
                          <IconButton
                            style={{ marginLeft: 10, marginTop: -10 }}
                            onPress={() => {
                              let isValid = false;
                              if (
                                (logInDetails["isValidateAccesscode"] ||
                                  logInDetails["isForgotPassword"]) &&
                                credentials["AccessCode"] !== ""
                              )
                                isValid = true;
                              else {
                                if (
                                  credentials["password"] !== "" ||
                                  credentials["AccessCode"] !== ""
                                )
                                  isValid = true;
                              }
                              if (isValid) handleLogInValidation();
                            }}
                            disable={disabledButton === "loginValidate"}
                            title={
                              logInDetails["isValidateAccesscode"] ||
                              logInDetails["isForgotPassword"]
                                ? "Validate Access Code"
                                : "Login"
                            }
                          />
                        </>
                      ) : null} */}
                      {currentPage === "addCellPhone" && (
                        <View style={{ margin: 10 }}>
                          <InputBox
                            label="Cell Phone Number"
                            autoFocus
                            keyboardType="numeric"
                            placeholder="Cell Phone Number"
                            onBlur={() => {
                              let text = logInDetails["CellPhone"] || "";
                              text = text
                                .replaceAll("-", "")
                                .replaceAll("(", "")
                                .replaceAll(")", "")
                                .replaceAll(" ", "");
                              //console.log(13);
                              setLoginDetails({
                                ...logInDetails,
                                ...{
                                  CellPhone: text,
                                  formatedCellPhone: FormatPhoneLogin(text),
                                },
                              });
                            }}
                            onChangeText={(text) => {
                              try {
                                text = text
                                  .replaceAll("-", "")
                                  .replaceAll("(", "")
                                  .replaceAll(")", "")
                                  .replaceAll(" ", "");
                                setLoginDetails({
                                  ...logInDetails,
                                  ...{
                                    CellPhone: text,
                                    formatedCellPhone: text,
                                  },
                                });
                              } catch (e) {
                                log("Cell Phone Number ====> ", e);
                              }
                            }}
                            value={logInDetails["formatedCellPhone"]}
                          />
                          <View
                            style={{ flexDirection: "row", display: "flex" }}
                          >
                            <IconButton
                              style={{ marginRight: 10 }}
                              onPress={(e) => {
                                if (logInDetails["CellPhone"] === "") {
                                  setErrorMessage({
                                    text: "Enter a Cell Phone Number.",
                                    color: "#999",
                                    italic: false,
                                  });
                                } else {
                                  setProcessingStatus("addCellPhone");
                                  setErrorMessage({});
                                  setHideSecureEmail(true);
                                  setCurrentPage("enterAccessCode");
                                  setCredentials({
                                    ...credentials,
                                    AccessCode: "",
                                  });
                                  handleAPI({
                                    name: "SendTextToMobile",
                                    params: {
                                      WebLoginId: logInDetails["WebLoginId"],
                                      Phone: logInDetails["CellPhone"],
                                    },
                                  }).then((response) => {
                                    try {
                                      let sList = response.split("|");
                                      if (sList.length > 2) {
                                        if (sList[3] == "0")
                                          setErrorMessage({
                                            text: sList[1],
                                            color: "#999",
                                            italic: false,
                                          });

                                        if (sList[3] == "1") {
                                          let logDe = {
                                            ...logInDetails,
                                            AccessCode: sList[2],
                                          };
                                          setProcessingStatus(null);
                                          setLoginDetails(logDe);
                                          return false;
                                        }
                                      }
                                    } catch (e) {}
                                  });
                                }
                              }}
                              title="Save"
                              loading={processingStatus === "addCellPhone"}
                              sStyle={{
                                minWidth: 30,
                                height: 15,
                              }}
                            />
                            <IconButton
                              onPress={() => {
                                // handleLoginClick(-1);
                                handleLogin(-1, logInDetails);
                              }}
                              title="Skip"
                            />
                          </View>
                        </View>
                      )}
                      {errorMessage["text"] !== "" && (
                        <CustomText
                          bold={true}
                          italic={
                            errorMessage["italic"] === undefined ? true : false
                          }
                          style={[
                            styles.errorMessage,
                            {
                              color: errorMessage["color"] || "red",
                              marginTop: -5,
                              marginBottom: 0,
                            },
                          ]}
                        >
                          {errorMessage["text"]}
                        </CustomText>
                      )}
                      {complianceMsg && (
                        <>
                          <CustomText
                            bold={false}
                            italic={true}
                            style={[
                              styles.cssCompMsg,
                              {
                                //color: errorMessage["color"] || "red",
                                marginTop: -5,
                              },
                            ]}
                          >
                            {CompMsg}
                          </CustomText>
                          <View
                            style={{
                              display: "inline",
                              marginBottom: 5,
                              marginLeft: 15,
                            }}
                          >
                            <CustomText
                              onPress={() => handleOpenPage(1)}
                              bold={false}
                              style={[
                                styles.footText,
                                {
                                  color: "blue",
                                },
                              ]}
                            >
                              Terms and conditions
                            </CustomText>
                            <CustomText
                              onPress={() => handleOpenPage(2)}
                              bold={false}
                              style={[
                                styles.footText,
                                {
                                  color: "blue",
                                  marginLeft: 15,
                                },
                              ]}
                            >
                              Privacy Policy
                            </CustomText>
                          </View>
                        </>
                      )}

                      {currentPage === "enterPassword" ||
                      currentPage === "enterAccessCode" ? (
                        <>
                          <View
                            style={{
                              margin: 10,
                              flexDirection: "row",
                              alignItems: "center",
                              marginTop: 0,
                            }}
                          >
                            <Checkbox
                              value={isRemember}
                              onValueChange={() => {
                                setIsRemember(!isRemember);
                              }}
                              style={{
                                marginTop: web ? -10 : 0,
                              }}
                              color={isRemember ? "#0075ff" : undefined}
                            />
                            <View style={{ flexDirection: "column" }}>
                              <CustomText
                                bold={true}
                                style={{
                                  color: "#999",
                                  fontSize: isMobileWeb ? 13 : 15,
                                  marginLeft: 10,
                                }}
                                onPress={() => {
                                  setIsRemember(!isRemember);
                                }}
                              >
                                Remember me on this device
                                {web && (
                                  <CustomText
                                    style={{
                                      fontSize: isMobileWeb ? 9 : 12,
                                      color: "#999",
                                    }}
                                    bold={true}
                                    italic={true}
                                  >
                                    {"\n"}(not recommended on public computers)
                                  </CustomText>
                                )}
                              </CustomText>
                            </View>

                            <IconButton
                              style={{ marginLeft: "auto", marginTop: -10 }}
                              onPress={() => {
                                let isValid = false;
                                if (
                                  (logInDetails["isValidateAccesscode"] ||
                                    logInDetails["isForgotPassword"]) &&
                                  credentials["AccessCode"] !== ""
                                )
                                  isValid = true;
                                else {
                                  if (
                                    credentials["password"] !== "" ||
                                    credentials["AccessCode"] !== ""
                                  )
                                    isValid = true;
                                }
                                if (isValid) handleLogInValidation();
                              }}
                              disable={disabledButton === "loginValidate"}
                              title={
                                logInDetails["isValidateAccesscode"] ||
                                logInDetails["isForgotPassword"]
                                  ? //? "Validate Access Code"
                                    "Validate Code"
                                  : "Login"
                              }
                              loading={processingStatus === "validating"}
                              sStyle={{
                                minWidth: 35,
                                height: 18,
                              }}
                            />
                          </View>

                          {(!logInDetails["isForgotPassword"] &&
                            !currentPage === "enterAccessCode") ||
                          currentPage === "enterPassword" ? (
                            <>
                              <View>
                                <View
                                  style={{
                                    borderBottomColor: "black",
                                    borderBottomWidth: 1,
                                    margin: 10,
                                  }}
                                />
                                <View
                                  style={{
                                    marginBottom: 20,
                                    marginHorizontal: 10,
                                  }}
                                >
                                  <CustomText
                                    style={{
                                      fontSize: 17,
                                      color: "#999",
                                      marginBottom: 15,
                                    }}
                                    bold={true}
                                  >
                                    Troubles? No Worries!
                                  </CustomText>
                                  <View
                                    style={{
                                      flexDirection: "row",
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    <CustomText
                                      onPress={() => {
                                        isForgotPassword = true;

                                        setErrorMessage({ text: "" });
                                        if (
                                          credentials["userName"].indexOf(
                                            "@"
                                          ) !== -1
                                        )
                                          handleAccessCodeLogin(1, {
                                            isForgotPassword: true,
                                          });
                                        else
                                          handleAccessCodeLogin(2, {
                                            isForgotPassword: true,
                                          });
                                      }}
                                      bold={true}
                                      style={[
                                        styles.footText,
                                        { fontSize: 13 },
                                      ]}
                                    >
                                      Forgot Password?
                                    </CustomText>
                                    <CustomText
                                      italic={true}
                                      bold={true}
                                      style={{ color: "#999", fontSize: 12 }}
                                    >
                                      {"  "}
                                      or just{"  "}
                                    </CustomText>
                                    <CustomText
                                      bold={true}
                                      onPress={() => {
                                        try {
                                          if (credentials["userName"] === "") {
                                            setErrorMessage({
                                              text: "Invalid Username",
                                            });
                                            return false;
                                          }
                                        } catch (e) {
                                          log(
                                            "Send me a verification code ===> ",
                                            e
                                          );
                                        }

                                        if (
                                          credentials["userName"].indexOf(
                                            "@"
                                          ) !== -1
                                        )
                                          handleAccessCodeLogin(1);
                                        else handleAccessCodeLogin(2);
                                      }}
                                      style={[
                                        styles.footText,
                                        { fontSize: 13 },
                                      ]}
                                    >
                                      Send me a verification code
                                    </CustomText>
                                  </View>
                                </View>
                              </View>
                            </>
                          ) : null}
                        </>
                      ) : null}
                      {currentPage === "multiLogin" && (
                        <>
                          <View style={styles.imgMultipleLoginWrapper}>
                            <TouchableOpacity
                              activeOpacity={1}
                              onPress={() => {
                                handleCloseOtherSession(logInDetails);
                                handleClearState(0);
                                handleSetStoredCredential(2);
                              }}
                              style={{
                                width: web ? "34%" : "50%",
                              }}
                            >
                              <Image
                                resizeMode="contain"
                                style={styles.imgMultipleLogin}
                                source={require("../../assets/WaitImg.png")}
                              />
                            </TouchableOpacity>
                            <TouchableOpacity
                              activeOpacity={1}
                              style={{
                                width: web ? "33%" : "50%",
                                alignContent: "center",
                                alignSelf: "center",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                              onPress={() => {
                                setProcessingStatus("proceeding");
                                if (logInDetails["AutoRedirect"])
                                  handleLogin(1, logInDetails);
                                else handleLoginClick(1);
                              }}
                            >
                              <Image
                                resizeMode="contain"
                                style={styles.imgMultipleLogin}
                                source={require("../../assets/ProceedImg.png")}
                              />
                              {["proceeding"].includes(processingStatus) && (
                                <View
                                  style={[
                                    styles.imgMultipleLogin,
                                    {
                                      position: "absolute",
                                      height: 140,
                                      width: "82%",
                                      backgroundColor: "#fff",
                                    },
                                  ]}
                                >
                                  <ArrowSpinner
                                    size={25}
                                    duration={1500}
                                    isSpinner
                                    style={{
                                      flex: 1,
                                    }}
                                  />
                                </View>
                              )}
                            </TouchableOpacity>
                          </View>
                          <View
                            style={{
                              margin: 10,
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <Checkbox
                              value={isRemember}
                              onValueChange={() => {
                                setIsRemember(!isRemember);
                              }}
                              style={{
                                marginTop: web ? -10 : 0,
                              }}
                              color={isRemember ? "#0075ff" : undefined}
                            />
                            <View style={{ flexDirection: "row" }}>
                              <CustomText
                                bold={true}
                                style={{
                                  color: "#999",
                                  fontSize: isMobileWeb ? 13 : 15,
                                  marginLeft: 10,
                                }}
                                onPress={() => {
                                  setIsRemember(!isRemember);
                                }}
                              >
                                Remember me on this device
                                {web && (
                                  <CustomText
                                    style={{
                                      fontSize: isMobileWeb ? 9 : 12,
                                      color: "#999",
                                    }}
                                    bold={true}
                                    italic={true}
                                  >
                                    {"\n"}(not recommended on public computers)
                                  </CustomText>
                                )}
                              </CustomText>
                            </View>
                          </View>
                        </>
                      )}
                      {currentPage === "enterAccessCode" && (
                        <View style={{ margin: 10 }}>
                          <View
                            style={{
                              borderBottomColor: "black",
                              borderBottomWidth: 1,
                              marginTop: 20,
                            }}
                          />
                          <View
                            style={{
                              marginTop: 30,
                              marginBottom: 20,
                            }}
                          >
                            {accesscodeWarningMsg ? (
                              <CustomText
                                style={{
                                  fontSize: 16,
                                  color: "#999",
                                  marginBottom: 15,
                                  marginTop: -15,
                                }}
                                bold={true}
                              >
                                {accesscodeWarningMsg}
                              </CustomText>
                            ) : null}
                            <CustomText
                              style={{
                                fontSize: 17,
                                color: "#999",
                                marginBottom: 15,
                              }}
                              bold={true}
                            >
                              Didn't get the code?
                            </CustomText>
                            <View
                              style={{
                                flexDirection: "row",
                                justifyContent: "space-between",
                              }}
                            >
                              <View>{getSecureEmail()}</View>
                              <View>{getSecurePhone()}</View>
                            </View>
                          </View>
                        </View>
                      )}
                      {currentPage === "setPassword&Login" && (
                        <>
                          <View style={{ marginLeft: 30, marginTop: 20 }}>
                            <CustomText
                              bold={true}
                              style={{
                                fontSize: 18,
                                color: "#999",
                                marginBottom: 5,
                              }}
                            >
                              Set a password or skip and login.
                            </CustomText>
                          </View>
                          <View
                            style={{
                              margin: 20,
                              marginBottom: 30,
                              flexDirection: "row",
                              justifyContent: "space-evenly",
                            }}
                          >
                            <IconButton
                              loading={processingStatus === "loginNow"}
                              sStyle={{
                                minWidth: 75,
                                height: 15,
                              }}
                              disable={processingStatus === "loginNow"}
                              onPress={() => {
                                setProcessingStatus("loginNow");
                                handleLogin(undefined, logInDetails);
                              }}
                              title="Login Now"
                            />
                            <IconButton
                              disable={processingStatus === "loginNow"}
                              onPress={() => {
                                setCurrentPage("newPassword");
                                setNewPassword({
                                  password: "",
                                  confirmPassword: "",
                                });
                                setnewPasswordMessage({
                                  passwordMsg: "",
                                  confirmPasswordMsg: "",
                                });
                                setNewIsPasswordSecure({
                                  password: true,
                                  confirmPassword: true,
                                });
                              }}
                              title="Set Password"
                              buttonType="secondary"
                            />
                          </View>
                        </>
                      )}
                      {currentPage === "newPassword" && (
                        <View
                          style={{ marginHorizontal: 10, marginBottom: 10 }}
                        >
                          <CustomText
                            //bold={true}
                            style={{
                              fontSize: 15,
                              color: "#999",
                              marginBottom: 20,
                            }}
                          >
                            {/* {`Password: Please create your password below. The password must contain:
Minimum length of 6 characters Must contain 1 number, 1 capital letter, and 1 special character such as: (@!*&).`} */}
                            {`Please create your password below: 

Password Requirments: 
Minimum length of 6 characters, 1 number, 1 capital letter, and 1 special character such as: (@!*&).`}
                          </CustomText>
                          <View>
                            <View>
                              <InputBox
                                label="Password"
                                autoFocus
                                secureTextEntry={
                                  newIsPasswordSecure["password"]
                                }
                                placeholder="Please enter your password..."
                                onChangeText={(text) => {
                                  validatePassword("password", text);
                                }}
                                value={newPassword["password"]}
                                border="#333"
                              />

                              <CustomText
                                style={{
                                  position: "absolute",
                                  right: 20,
                                  top: 20,
                                }}
                                onPress={() => {
                                  setNewIsPasswordSecure({
                                    ...newIsPasswordSecure,
                                    password: !newIsPasswordSecure["password"],
                                  });
                                }}
                              >
                                {newIsPasswordSecure["password"] ? (
                                  <FontAwesome
                                    name="eye"
                                    color="gray"
                                    size={15}
                                  />
                                ) : (
                                  <FontAwesome
                                    name="eye-slash"
                                    color="gray"
                                    size={15}
                                  />
                                )}
                              </CustomText>

                              {newPasswordMessage["passwordMsg"] !== "" &&
                                newPassword["password"] !== "" && (
                                  <>{newPasswordMessage["passwordMsg"]}</>
                                )}
                            </View>
                            <View>
                              <InputBox
                                label="Confirm Password"
                                secureTextEntry={
                                  newIsPasswordSecure["confirmPassword"]
                                }
                                placeholder="Confirm your password..."
                                onChangeText={(text) => {
                                  validatePassword("confirmPassword", text);
                                }}
                                value={newPassword["confirmPassword"]}
                                border="#333"
                              />
                              <CustomText
                                style={{
                                  position: "absolute",
                                  right: 20,
                                  top: 20,
                                }}
                                onPress={() => {
                                  setNewIsPasswordSecure({
                                    ...newIsPasswordSecure,
                                    confirmPassword:
                                      !newIsPasswordSecure["confirmPassword"],
                                  });
                                }}
                              >
                                {newIsPasswordSecure["confirmPassword"] ? (
                                  <FontAwesome
                                    name="eye"
                                    color="gray"
                                    size={15}
                                  />
                                ) : (
                                  <FontAwesome
                                    name="eye-slash"
                                    color="gray"
                                    size={15}
                                  />
                                )}
                              </CustomText>
                              {newPasswordMessage["confirmPasswordMsg"] !==
                                "" &&
                                newPassword["confirmPassword"] !== "" && (
                                  <>
                                    {newPasswordMessage["confirmPasswordMsg"]}
                                  </>
                                )}
                            </View>
                            <IconButton
                              onPress={() => {
                                if (newPassword["password"] === "") {
                                  setPasswordMisMatch(
                                    "Please enter the New Password."
                                  );
                                  return false;
                                }
                                if (newPassword["confirmPassword"] === "") {
                                  setPasswordMisMatch(
                                    "Please enter the Confirm New Password."
                                  );
                                  return false;
                                }
                                if (
                                  newPassword["confirmPassword"] !==
                                  newPassword["password"]
                                ) {
                                  setPasswordMisMatch(
                                    "The new password and confirmed password do not match."
                                  );
                                  return false;
                                }

                                let strength = 0,
                                  text = newPassword["password"];
                                if (text.length > 6) strength += 1;
                                if (
                                  text.match(/([A-Z])/) &&
                                  text.match(/([0-9])/)
                                )
                                  strength += 1;
                                if (
                                  text.match(/([!,%,&,@,#,jQuery,^,*,?,_,~])/)
                                )
                                  strength += 1;
                                if (strength < 3) {
                                  setPasswordMisMatch(
                                    `Please create your password below: 

Password Requirments: 
Minimum length of 6 characters, 1 number, 1 capital letter, and 1 special character such as: (@!*&).`
                                  );
                                  return false;
                                }
                                strength = 0;
                                text = newPassword["confirmPassword"];
                                if (text.length > 6) strength += 1;
                                if (
                                  text.match(/([A-Z])/) &&
                                  text.match(/([0-9])/)
                                )
                                  strength += 1;
                                if (
                                  text.match(/([!,%,&,@,#,jQuery,^,*,?,_,~])/)
                                )
                                  strength += 1;
                                if (strength < 3) {
                                  setPasswordMisMatch(
                                    `Please create your password below: 

 Password Requirments: 
 Minimum length of 6 characters, 1 number, 1 capital letter, and 1 special character such as: (@!*&).`
                                  );
                                  return false;
                                }
                                if (
                                  newPassword["password"] ===
                                  newPassword["confirmPassword"]
                                ) {
                                  handleAPI({
                                    name: "SavePasswordRedirect",
                                    params: {
                                      WebLoginId: logInDetails["WebLoginId"],
                                      Password: newPassword["password"],
                                    },
                                  }).then((response) => {
                                    response =
                                      JSON.parse(response)["Table"][0][
                                        "Column1"
                                      ].toString();
                                    response = new XMLParser().parseFromString(
                                      response
                                    )["children"][0]["attributes"];
                                    let msg = response["Message"];
                                    setErrorMessage({ text: "" });
                                    if (
                                      msg === "Password updated successfully."
                                    ) {
                                      setProcessingStatus("Save&Login");
                                      handleLogin(1, logInDetails);
                                    } else setPasswordMisMatch(msg);
                                  });
                                }
                              }}
                              title="Save & Login"
                              loading={processingStatus == "Save&Login"}
                              sStyle={{
                                minWidth: 30,
                                height: 15,
                              }}
                            />
                            {passwordMisMatch !== "" && (
                              <View
                                style={{
                                  borderWidth: 1,
                                  borderColor: "#ebccd1",
                                  backgroundColor: "#f2dede",
                                  borderRadius: 5,
                                  marginBottom: 10,
                                }}
                              >
                                <CustomText
                                  style={{
                                    color: "#999",
                                    fontSize: 15,
                                    padding: 15,
                                  }}
                                  //bold={true}
                                >
                                  {passwordMisMatch}
                                </CustomText>
                              </View>
                            )}
                          </View>
                        </View>
                      )}
                    </View>
                  </>
                )}
                <View style={styles.footContainer}>
                  <>
                    {loginFrom === "ratequote" && (
                      <>
                        {currentPage === "emailOnly" ? (
                          <CustomText
                            onPress={(e) => {
                              try {
                                window.parent.document.getElementById(
                                  "CreateNewUserModal01"
                                ).style.display = "none";
                                window.parent.fncancellockconfirm();
                              } catch (e) {}
                            }}
                            bold={true}
                            style={[
                              styles.footText,
                              {
                                textDecorationLine: "none",
                                borderWidth: 0,
                              },
                            ]}
                          >
                            ←{"  "}Cancel
                          </CustomText>
                        ) : (
                          <CustomText
                            onPress={(e) => {
                              handleClearState(0);
                            }}
                            bold={true}
                            style={[
                              styles.footText,
                              {
                                textDecorationLine: "none",
                                borderWidth: 0,
                                display:
                                  currentPage === "emailOnly" ? "none" : null,
                              },
                            ]}
                          >
                            ← Back
                          </CustomText>
                        )}
                      </>
                    )}
                    {currentPage === "emailOnly" &&
                    (showFooter || isTerminated) ? (
                      <CustomText
                        onPress={handleCreateNewAccClick}
                        bold={true}
                        style={styles.footText}
                      >
                        Create New Account
                      </CustomText>
                    ) : (
                      <>
                        {loginFrom !== "ratequote" &&
                          action !== "changePassword" && (
                            <CustomText
                              onPress={(e) => {
                                handleClearState(0);
                                if (loginFrom === "RunScenario") {
                                  setLoginDetails((prevLoginDetails) => {
                                    return {
                                      enableEmailField: true,
                                    };
                                  });
                                  setCredentials((prevCredentials) => {
                                    return {
                                      existingFlowRunScenario: true,
                                    };
                                  });
                                  handleSetEmailId(false);
                                }
                              }}
                              bold={true}
                              style={[
                                styles.footText,
                                {
                                  textDecorationLine: "none",
                                  borderWidth: 0,
                                  display:
                                    currentPage === "emailOnly" ? "none" : null,
                                },
                              ]}
                            >
                              ← Back
                            </CustomText>
                          )}
                      </>
                    )}
                    {showFooter &&
                      !isTerminated &&
                      (currentPage === "emailOnly" ||
                        currentPage === "loginOption") && (
                        <CustomText
                          onPress={handleForgotPassword}
                          style={styles.footText}
                          bold={true}
                        >
                          Forgot Password
                        </CustomText>
                      )}
                  </>
                </View>
              </View>
            </ScrollContainer>
          </View>
          {web && !IISSessionId && !__DEV__ && <Frame />}
        </View>
      )}
    </>
  );
};
//Style Section
const styles = StyleSheet.create({
  container: {
    color: "#333",
    backgroundColor: "#f5f5f5",
    borderWidth: 1,
    borderColor: "#ddd",
    borderRadius: 5,
    // width: isIOS || isAndroid ? "80%" : "96%",
    //width: "96%",
    width: "100%",
  },
  headContainer: {
    padding: 25,
    // paddingBottom: 10,
    // paddingRight: 25,
    // paddingLeft: 25,
  },
  headText: {
    fontSize: 18,
    color: "#999",
  },
  footContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 10,
    marginTop: 0,
    height: 30,
  },
  footText: {
    fontSize: 12,
    color: "#999",
    textDecorationLine: android ? "none" : "underline",
    borderBottomWidth: android ? 1 : 0,
    borderBottomColor: "#999",
  },
  bodyContainer: {
    backgroundColor: "#fff",
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#ddd",
    paddingTop: 10,
  },
  errorMessage: {
    color: "red",
    fontSize: 15,
    padding: 10,
  },
  imgMultipleLogin: {
    width: "94%",
    height: web ? 160 : 200,
    marginTop: web ? 50 : null,
  },
  imgMultipleLoginWrapper: {
    flexDirection: "row",
    marginBottom: 30,
    justifyContent: !web ? "space-between" : "space-evenly",
  },
  cssCompMsg: {
    fontSize: 11,
    color: "#999",
    textDecorationLine: "none",
    borderBottomWidth: 0,
    borderBottomColor: "#999",
    padding: 10,
  },
});
export default LoginWeb;
